export enum ISO3166_2_Alpha2 {
  AF_BDS = "AF-BDS",
  AF_BDG = "AF-BDG",
  AF_BGL = "AF-BGL",
  AF_BAL = "AF-BAL",
  AF_BAM = "AF-BAM",
  AF_DAY = "AF-DAY",
  AF_FRA = "AF-FRA",
  AF_FYB = "AF-FYB",
  AF_GHA = "AF-GHA",
  AF_GHO = "AF-GHO",
  AF_HEL = "AF-HEL",
  AF_HER = "AF-HER",
  AF_JOW = "AF-JOW",
  AF_KAB = "AF-KAB",
  AF_KAN = "AF-KAN",
  AF_KAP = "AF-KAP",
  AF_KHO = "AF-KHO",
  AF_KNR = "AF-KNR",
  AF_KDZ = "AF-KDZ",
  AF_LAG = "AF-LAG",
  AF_LOG = "AF-LOG",
  AF_NAN = "AF-NAN",
  AF_NIM = "AF-NIM",
  AF_NUR = "AF-NUR",
  AF_PKA = "AF-PKA",
  AF_PIA = "AF-PIA",
  AF_PAN = "AF-PAN",
  AF_PAR = "AF-PAR",
  AF_SAM = "AF-SAM",
  AF_SAR = "AF-SAR",
  AF_TAK = "AF-TAK",
  AF_URU = "AF-URU",
  AF_WAR = "AF-WAR",
  AF_ZAB = "AF-ZAB",
  AL_01 = "AL-01",
  AL_09 = "AL-09",
  AL_02 = "AL-02",
  AL_03 = "AL-03",
  AL_04 = "AL-04",
  AL_05 = "AL-05",
  AL_06 = "AL-06",
  AL_07 = "AL-07",
  AL_08 = "AL-08",
  AL_10 = "AL-10",
  AL_11 = "AL-11",
  AL_12 = "AL-12",
  DZ_01 = "DZ-01",
  DZ_44 = "DZ-44",
  DZ_46 = "DZ-46",
  DZ_16 = "DZ-16",
  DZ_23 = "DZ-23",
  DZ_05 = "DZ-05",
  DZ_08 = "DZ-08",
  DZ_06 = "DZ-06",
  DZ_07 = "DZ-07",
  DZ_09 = "DZ-09",
  DZ_34 = "DZ-34",
  DZ_10 = "DZ-10",
  DZ_35 = "DZ-35",
  DZ_02 = "DZ-02",
  DZ_25 = "DZ-25",
  DZ_17 = "DZ-17",
  DZ_32 = "DZ-32",
  DZ_39 = "DZ-39",
  DZ_36 = "DZ-36",
  DZ_47 = "DZ-47",
  DZ_24 = "DZ-24",
  DZ_33 = "DZ-33",
  DZ_18 = "DZ-18",
  DZ_40 = "DZ-40",
  DZ_03 = "DZ-03",
  DZ_28 = "DZ-28",
  DZ_29 = "DZ-29",
  DZ_26 = "DZ-26",
  DZ_43 = "DZ-43",
  DZ_27 = "DZ-27",
  DZ_45 = "DZ-45",
  DZ_31 = "DZ-31",
  DZ_30 = "DZ-30",
  DZ_04 = "DZ-04",
  DZ_48 = "DZ-48",
  DZ_20 = "DZ-20",
  DZ_19 = "DZ-19",
  DZ_22 = "DZ-22",
  DZ_21 = "DZ-21",
  DZ_41 = "DZ-41",
  DZ_11 = "DZ-11",
  DZ_12 = "DZ-12",
  DZ_14 = "DZ-14",
  DZ_37 = "DZ-37",
  DZ_42 = "DZ-42",
  DZ_38 = "DZ-38",
  DZ_15 = "DZ-15",
  DZ_13 = "DZ-13",
  AD_07 = "AD-07",
  AD_02 = "AD-02",
  AD_03 = "AD-03",
  AD_08 = "AD-08",
  AD_04 = "AD-04",
  AD_05 = "AD-05",
  AD_06 = "AD-06",
  AO_BGO = "AO-BGO",
  AO_BGU = "AO-BGU",
  AO_BIE = "AO-BIE",
  AO_CAB = "AO-CAB",
  AO_CNN = "AO-CNN",
  AO_HUA = "AO-HUA",
  AO_HUI = "AO-HUI",
  AO_CCU = "AO-CCU",
  AO_CNO = "AO-CNO",
  AO_CUS = "AO-CUS",
  AO_LUA = "AO-LUA",
  AO_LNO = "AO-LNO",
  AO_LSU = "AO-LSU",
  AO_MAL = "AO-MAL",
  AO_MOX = "AO-MOX",
  AO_NAM = "AO-NAM",
  AO_UIG = "AO-UIG",
  AO_ZAI = "AO-ZAI",
  AG_03 = "AG-03",
  AG_04 = "AG-04",
  AG_05 = "AG-05",
  AG_06 = "AG-06",
  AG_07 = "AG-07",
  AG_08 = "AG-08",
  AG_10 = "AG-10",
  AG_11 = "AG-11",
  AR_C = "AR-C",
  AR_B = "AR-B",
  AR_K = "AR-K",
  AR_H = "AR-H",
  AR_U = "AR-U",
  AR_X = "AR-X",
  AR_W = "AR-W",
  AR_E = "AR-E",
  AR_P = "AR-P",
  AR_Y = "AR-Y",
  AR_L = "AR-L",
  AR_F = "AR-F",
  AR_M = "AR-M",
  AR_N = "AR-N",
  AR_Q = "AR-Q",
  AR_R = "AR-R",
  AR_A = "AR-A",
  AR_J = "AR-J",
  AR_D = "AR-D",
  AR_Z = "AR-Z",
  AR_S = "AR-S",
  AR_G = "AR-G",
  AR_V = "AR-V",
  AR_T = "AR-T",
  AM_ER = "AM-ER",
  AM_AG = "AM-AG",
  AM_AR = "AM-AR",
  AM_AV = "AM-AV",
  AM_GR = "AM-GR",
  AM_KT = "AM-KT",
  AM_LO = "AM-LO",
  AM_SH = "AM-SH",
  AM_SU = "AM-SU",
  AM_TV = "AM-TV",
  AM_VD = "AM-VD",
  AU_NSW = "AU-NSW",
  AU_QLD = "AU-QLD",
  AU_SA = "AU-SA",
  AU_TAS = "AU-TAS",
  AU_VIC = "AU-VIC",
  AU_WA = "AU-WA",
  AU_ACT = "AU-ACT",
  AU_NT = "AU-NT",
  AT_1 = "AT-1",
  AT_2 = "AT-2",
  AT_3 = "AT-3",
  AT_4 = "AT-4",
  AT_5 = "AT-5",
  AT_6 = "AT-6",
  AT_7 = "AT-7",
  AT_8 = "AT-8",
  AT_9 = "AT-9",
  AZ_NX = "AZ-NX",
  AZ_BA = "AZ-BA",
  AZ_GA = "AZ-GA",
  AZ_LA = "AZ-LA",
  AZ_MI = "AZ-MI",
  AZ_NA = "AZ-NA",
  AZ_NV = "AZ-NV",
  AZ_SA = "AZ-SA",
  AZ_SR = "AZ-SR",
  AZ_SM = "AZ-SM",
  AZ_XA = "AZ-XA",
  AZ_YE = "AZ-YE",
  AZ_ABS = "AZ-ABS",
  AZ_AGC = "AZ-AGC",
  AZ_AGM = "AZ-AGM",
  AZ_AGS = "AZ-AGS",
  AZ_AGA = "AZ-AGA",
  AZ_AGU = "AZ-AGU",
  AZ_AST = "AZ-AST",
  AZ_BAB = "AZ-BAB",
  AZ_BAL = "AZ-BAL",
  AZ_BAR = "AZ-BAR",
  AZ_BEY = "AZ-BEY",
  AZ_BIL = "AZ-BIL",
  AZ_CAB = "AZ-CAB",
  AZ_CAL = "AZ-CAL",
  AZ_CUL = "AZ-CUL",
  AZ_DAS = "AZ-DAS",
  AZ_FUZ = "AZ-FUZ",
  AZ_GAD = "AZ-GAD",
  AZ_GOR = "AZ-GOR",
  AZ_GOY = "AZ-GOY",
  AZ_GYG = "AZ-GYG",
  AZ_HAC = "AZ-HAC",
  AZ_IMI = "AZ-IMI",
  AZ_ISM = "AZ-ISM",
  AZ_KAL = "AZ-KAL",
  AZ_KAN = "AZ-KAN",
  AZ_KUR = "AZ-KUR",
  AZ_LAC = "AZ-LAC",
  AZ_LAN = "AZ-LAN",
  AZ_LER = "AZ-LER",
  AZ_MAS = "AZ-MAS",
  AZ_NEF = "AZ-NEF",
  AZ_OGU = "AZ-OGU",
  AZ_ORD = "AZ-ORD",
  AZ_QAB = "AZ-QAB",
  AZ_QAX = "AZ-QAX",
  AZ_QAZ = "AZ-QAZ",
  AZ_QOB = "AZ-QOB",
  AZ_QBA = "AZ-QBA",
  AZ_QBI = "AZ-QBI",
  AZ_QUS = "AZ-QUS",
  AZ_SAT = "AZ-SAT",
  AZ_SAB = "AZ-SAB",
  AZ_SBN = "AZ-SBN",
  AZ_SAD = "AZ-SAD",
  AZ_SAH = "AZ-SAH",
  AZ_SAK = "AZ-SAK",
  AZ_SAL = "AZ-SAL",
  AZ_SMI = "AZ-SMI",
  AZ_SKR = "AZ-SKR",
  AZ_SMX = "AZ-SMX",
  AZ_SAR = "AZ-SAR",
  AZ_SIY = "AZ-SIY",
  AZ_SUS = "AZ-SUS",
  AZ_TAR = "AZ-TAR",
  AZ_TOV = "AZ-TOV",
  AZ_UCA = "AZ-UCA",
  AZ_XAC = "AZ-XAC",
  AZ_XIZ = "AZ-XIZ",
  AZ_XCI = "AZ-XCI",
  AZ_XVD = "AZ-XVD",
  AZ_YAR = "AZ-YAR",
  AZ_YEV = "AZ-YEV",
  AZ_ZAN = "AZ-ZAN",
  AZ_ZAQ = "AZ-ZAQ",
  AZ_ZAR = "AZ-ZAR",
  BS_AK = "BS-AK",
  BS_BY = "BS-BY",
  BS_BI = "BS-BI",
  BS_BP = "BS-BP",
  BS_CI = "BS-CI",
  BS_CO = "BS-CO",
  BS_CS = "BS-CS",
  BS_CE = "BS-CE",
  BS_FP = "BS-FP",
  BS_CK = "BS-CK",
  BS_EG = "BS-EG",
  BS_EX = "BS-EX",
  BS_GC = "BS-GC",
  BS_HI = "BS-HI",
  BS_HT = "BS-HT",
  BS_IN = "BS-IN",
  BS_LI = "BS-LI",
  BS_MC = "BS-MC",
  BS_MG = "BS-MG",
  BS_MI = "BS-MI",
  BS_NP = "BS-NP",
  BS_NO = "BS-NO",
  BS_NS = "BS-NS",
  BS_NE = "BS-NE",
  BS_RI = "BS-RI",
  BS_RC = "BS-RC",
  BS_SS = "BS-SS",
  BS_SO = "BS-SO",
  BS_SA = "BS-SA",
  BS_SE = "BS-SE",
  BS_SW = "BS-SW",
  BS_WG = "BS-WG",
  BH_13 = "BH-13",
  BH_14 = "BH-14",
  BH_15 = "BH-15",
  BH_17 = "BH-17",
  BD_A = "BD-A",
  BD_B = "BD-B",
  BD_C = "BD-C",
  BD_D = "BD-D",
  BD_H = "BD-H",
  BD_E = "BD-E",
  BD_F = "BD-F",
  BD_G = "BD-G",
  BD_05 = "BD-05",
  BD_01 = "BD-01",
  BD_02 = "BD-02",
  BD_06 = "BD-06",
  BD_07 = "BD-07",
  BD_03 = "BD-03",
  BD_04 = "BD-04",
  BD_09 = "BD-09",
  BD_45 = "BD-45",
  BD_10 = "BD-10",
  BD_12 = "BD-12",
  BD_08 = "BD-08",
  BD_11 = "BD-11",
  BD_13 = "BD-13",
  BD_14 = "BD-14",
  BD_15 = "BD-15",
  BD_16 = "BD-16",
  BD_19 = "BD-19",
  BD_18 = "BD-18",
  BD_17 = "BD-17",
  BD_20 = "BD-20",
  BD_21 = "BD-21",
  BD_22 = "BD-22",
  BD_25 = "BD-25",
  BD_23 = "BD-23",
  BD_24 = "BD-24",
  BD_29 = "BD-29",
  BD_27 = "BD-27",
  BD_26 = "BD-26",
  BD_28 = "BD-28",
  BD_30 = "BD-30",
  BD_31 = "BD-31",
  BD_32 = "BD-32",
  BD_36 = "BD-36",
  BD_37 = "BD-37",
  BD_33 = "BD-33",
  BD_39 = "BD-39",
  BD_38 = "BD-38",
  BD_35 = "BD-35",
  BD_34 = "BD-34",
  BD_48 = "BD-48",
  BD_43 = "BD-43",
  BD_40 = "BD-40",
  BD_42 = "BD-42",
  BD_44 = "BD-44",
  BD_41 = "BD-41",
  BD_46 = "BD-46",
  BD_47 = "BD-47",
  BD_49 = "BD-49",
  BD_52 = "BD-52",
  BD_51 = "BD-51",
  BD_50 = "BD-50",
  BD_53 = "BD-53",
  BD_54 = "BD-54",
  BD_56 = "BD-56",
  BD_55 = "BD-55",
  BD_58 = "BD-58",
  BD_62 = "BD-62",
  BD_57 = "BD-57",
  BD_59 = "BD-59",
  BD_61 = "BD-61",
  BD_60 = "BD-60",
  BD_63 = "BD-63",
  BD_64 = "BD-64",
  BB_01 = "BB-01",
  BB_02 = "BB-02",
  BB_03 = "BB-03",
  BB_04 = "BB-04",
  BB_05 = "BB-05",
  BB_06 = "BB-06",
  BB_07 = "BB-07",
  BB_08 = "BB-08",
  BB_09 = "BB-09",
  BB_10 = "BB-10",
  BB_11 = "BB-11",
  BY_BR = "BY-BR",
  BY_HO = "BY-HO",
  BY_HR = "BY-HR",
  BY_MA = "BY-MA",
  BY_MI = "BY-MI",
  BY_VI = "BY-VI",
  BY_HM = "BY-HM",
  BE_BRU = "BE-BRU",
  BE_VLG = "BE-VLG",
  BE_WAL = "BE-WAL",
  BE_VAN = "BE-VAN",
  BE_WBR = "BE-WBR",
  BE_WHT = "BE-WHT",
  BE_WLG = "BE-WLG",
  BE_VLI = "BE-VLI",
  BE_WLX = "BE-WLX",
  BE_WNA = "BE-WNA",
  BE_VOV = "BE-VOV",
  BE_VBR = "BE-VBR",
  BE_VWV = "BE-VWV",
  BZ_BZ = "BZ-BZ",
  BZ_CY = "BZ-CY",
  BZ_CZL = "BZ-CZL",
  BZ_OW = "BZ-OW",
  BZ_SC = "BZ-SC",
  BZ_TOL = "BZ-TOL",
  BJ_AL = "BJ-AL",
  BJ_AK = "BJ-AK",
  BJ_AQ = "BJ-AQ",
  BJ_BO = "BJ-BO",
  BJ_CO = "BJ-CO",
  BJ_KO = "BJ-KO",
  BJ_DO = "BJ-DO",
  BJ_LI = "BJ-LI",
  BJ_MO = "BJ-MO",
  BJ_OU = "BJ-OU",
  BJ_PL = "BJ-PL",
  BJ_ZO = "BJ-ZO",
  BT_33 = "BT-33",
  BT_12 = "BT-12",
  BT_22 = "BT-22",
  BT_GA = "BT-GA",
  BT_13 = "BT-13",
  BT_44 = "BT-44",
  BT_42 = "BT-42",
  BT_11 = "BT-11",
  BT_43 = "BT-43",
  BT_23 = "BT-23",
  BT_45 = "BT-45",
  BT_14 = "BT-14",
  BT_31 = "BT-31",
  BT_15 = "BT-15",
  BT_41 = "BT-41",
  BT_TY = "BT-TY",
  BT_32 = "BT-32",
  BT_21 = "BT-21",
  BT_24 = "BT-24",
  BT_34 = "BT-34",
  BO_C = "BO-C",
  BO_H = "BO-H",
  BO_B = "BO-B",
  BO_L = "BO-L",
  BO_O = "BO-O",
  BO_N = "BO-N",
  BO_P = "BO-P",
  BO_S = "BO-S",
  BO_T = "BO-T",
  BA_BIH = "BA-BIH",
  BA_SRP = "BA-SRP",
  BA_BRC = "BA-BRC",
  BW_CE = "BW-CE",
  BW_CH = "BW-CH",
  BW_FR = "BW-FR",
  BW_GA = "BW-GA",
  BW_GH = "BW-GH",
  BW_JW = "BW-JW",
  BW_KG = "BW-KG",
  BW_KL = "BW-KL",
  BW_KW = "BW-KW",
  BW_LO = "BW-LO",
  BW_NE = "BW-NE",
  BW_NW = "BW-NW",
  BW_SP = "BW-SP",
  BW_SE = "BW-SE",
  BW_SO = "BW-SO",
  BW_ST = "BW-ST",
  BR_AC = "BR-AC",
  BR_AL = "BR-AL",
  BR_AP = "BR-AP",
  BR_AM = "BR-AM",
  BR_BA = "BR-BA",
  BR_CE = "BR-CE",
  BR_DF = "BR-DF",
  BR_ES = "BR-ES",
  BR_GO = "BR-GO",
  BR_MA = "BR-MA",
  BR_MT = "BR-MT",
  BR_MS = "BR-MS",
  BR_MG = "BR-MG",
  BR_PA = "BR-PA",
  BR_PB = "BR-PB",
  BR_PR = "BR-PR",
  BR_PE = "BR-PE",
  BR_PI = "BR-PI",
  BR_RJ = "BR-RJ",
  BR_RN = "BR-RN",
  BR_RS = "BR-RS",
  BR_RO = "BR-RO",
  BR_RR = "BR-RR",
  BR_SC = "BR-SC",
  BR_SP = "BR-SP",
  BR_SE = "BR-SE",
  BR_TO = "BR-TO",
  VG_VG = "VG-VG",
  BN_BE = "BN-BE",
  BN_BM = "BN-BM",
  BN_TE = "BN-TE",
  BN_TU = "BN-TU",
  BG_01 = "BG-01",
  BG_02 = "BG-02",
  BG_08 = "BG-08",
  BG_07 = "BG-07",
  BG_26 = "BG-26",
  BG_09 = "BG-09",
  BG_10 = "BG-10",
  BG_11 = "BG-11",
  BG_12 = "BG-12",
  BG_13 = "BG-13",
  BG_14 = "BG-14",
  BG_15 = "BG-15",
  BG_16 = "BG-16",
  BG_17 = "BG-17",
  BG_18 = "BG-18",
  BG_27 = "BG-27",
  BG_19 = "BG-19",
  BG_20 = "BG-20",
  BG_21 = "BG-21",
  BG_23 = "BG-23",
  BG_22 = "BG-22",
  BG_24 = "BG-24",
  BG_25 = "BG-25",
  BG_03 = "BG-03",
  BG_04 = "BG-04",
  BG_05 = "BG-05",
  BG_06 = "BG-06",
  BG_28 = "BG-28",
  BF_01 = "BF-01",
  BF_02 = "BF-02",
  BF_03 = "BF-03",
  BF_04 = "BF-04",
  BF_05 = "BF-05",
  BF_06 = "BF-06",
  BF_07 = "BF-07",
  BF_08 = "BF-08",
  BF_09 = "BF-09",
  BF_10 = "BF-10",
  BF_11 = "BF-11",
  BF_12 = "BF-12",
  BF_13 = "BF-13",
  BI_BB = "BI-BB",
  BI_BM = "BI-BM",
  BI_BL = "BI-BL",
  BI_BR = "BI-BR",
  BI_CA = "BI-CA",
  BI_CI = "BI-CI",
  BI_GI = "BI-GI",
  BI_KR = "BI-KR",
  BI_KY = "BI-KY",
  BI_KI = "BI-KI",
  BI_MA = "BI-MA",
  BI_MU = "BI-MU",
  BI_MY = "BI-MY",
  BI_MW = "BI-MW",
  BI_NG = "BI-NG",
  BI_RM = "BI-RM",
  BI_RT = "BI-RT",
  BI_RY = "BI-RY",
  KH_12 = "KH-12",
  KH_2 = "KH-2",
  KH_1 = "KH-1",
  KH_3 = "KH-3",
  KH_4 = "KH-4",
  KH_5 = "KH-5",
  KH_6 = "KH-6",
  KH_7 = "KH-7",
  KH_8 = "KH-8",
  KH_9 = "KH-9",
  KH_10 = "KH-10",
  KH_23 = "KH-23",
  KH_24 = "KH-24",
  KH_18 = "KH-18",
  KH_11 = "KH-11",
  KH_22 = "KH-22",
  KH_15 = "KH-15",
  KH_13 = "KH-13",
  KH_14 = "KH-14",
  KH_16 = "KH-16",
  KH_17 = "KH-17",
  KH_19 = "KH-19",
  KH_20 = "KH-20",
  KH_21 = "KH-21",
  KH_25 = "KH-25",
  CM_AD = "CM-AD",
  CM_CE = "CM-CE",
  CM_ES = "CM-ES",
  CM_EN = "CM-EN",
  CM_LT = "CM-LT",
  CM_NO = "CM-NO",
  CM_NW = "CM-NW",
  CM_SU = "CM-SU",
  CM_SW = "CM-SW",
  CM_OU = "CM-OU",
  CA_AB = "CA-AB",
  CA_BC = "CA-BC",
  CA_MB = "CA-MB",
  CA_NB = "CA-NB",
  CA_NL = "CA-NL",
  CA_NS = "CA-NS",
  CA_ON = "CA-ON",
  CA_PE = "CA-PE",
  CA_QC = "CA-QC",
  CA_SK = "CA-SK",
  CA_NT = "CA-NT",
  CA_NU = "CA-NU",
  CA_YT = "CA-YT",
  CV_B = "CV-B",
  CV_S = "CV-S",
  BQ_BO = "BQ-BO",
  BQ_SA = "BQ-SA",
  BQ_SE = "BQ-SE",
  CF_BGF = "CF-BGF",
  CF_BB = "CF-BB",
  CF_BK = "CF-BK",
  CF_HK = "CF-HK",
  CF_HM = "CF-HM",
  CF_HS = "CF-HS",
  CF_KG = "CF-KG",
  CF_LB = "CF-LB",
  CF_MB = "CF-MB",
  CF_NM = "CF-NM",
  CF_MP = "CF-MP",
  CF_UK = "CF-UK",
  CF_AC = "CF-AC",
  CF_OP = "CF-OP",
  CF_VK = "CF-VK",
  CF_KB = "CF-KB",
  CF_SE = "CF-SE",
  TD_BA = "TD-BA",
  TD_LC = "TD-LC",
  TD_BG = "TD-BG",
  TD_BO = "TD-BO",
  TD_HL = "TD-HL",
  TD_EO = "TD-EO",
  TD_EE = "TD-EE",
  TD_KA = "TD-KA",
  TD_LO = "TD-LO",
  TD_LR = "TD-LR",
  TD_ND = "TD-ND",
  TD_MA = "TD-MA",
  TD_MO = "TD-MO",
  TD_ME = "TD-ME",
  TD_GR = "TD-GR",
  TD_SA = "TD-SA",
  TD_MC = "TD-MC",
  TD_CB = "TD-CB",
  TD_SI = "TD-SI",
  TD_TA = "TD-TA",
  TD_TI = "TD-TI",
  TD_OD = "TD-OD",
  TD_WF = "TD-WF",
  CL_AI = "CL-AI",
  CL_AN = "CL-AN",
  CL_AP = "CL-AP",
  CL_AR = "CL-AR",
  CL_AT = "CL-AT",
  CL_BI = "CL-BI",
  CL_CO = "CL-CO",
  CL_LI = "CL-LI",
  CL_LL = "CL-LL",
  CL_LR = "CL-LR",
  CL_MA = "CL-MA",
  CL_ML = "CL-ML",
  CL_NB = "CL-NB",
  CL_RM = "CL-RM",
  CL_TA = "CL-TA",
  CL_VS = "CL-VS",
  CN_AH = "CN-AH",
  CN_BJ = "CN-BJ",
  CN_CQ = "CN-CQ",
  CN_FJ = "CN-FJ",
  CN_GD = "CN-GD",
  CN_GS = "CN-GS",
  CN_GX = "CN-GX",
  CN_GZ = "CN-GZ",
  CN_HA = "CN-HA",
  CN_HB = "CN-HB",
  CN_HE = "CN-HE",
  CN_HI = "CN-HI",
  CN_HK = "CN-HK",
  CN_HL = "CN-HL",
  CN_HN = "CN-HN",
  CN_JL = "CN-JL",
  CN_JS = "CN-JS",
  CN_JX = "CN-JX",
  CN_LN = "CN-LN",
  CN_MO = "CN-MO",
  CN_NM = "CN-NM",
  CN_NX = "CN-NX",
  CN_QH = "CN-QH",
  CN_SC = "CN-SC",
  CN_SD = "CN-SD",
  CN_SH = "CN-SH",
  CN_SN = "CN-SN",
  CN_SX = "CN-SX",
  CN_TJ = "CN-TJ",
  CN_TW = "CN-TW",
  CN_XJ = "CN-XJ",
  CN_XZ = "CN-XZ",
  CN_YN = "CN-YN",
  CN_ZJ = "CN-ZJ",
  CO_DC = "CO-DC",
  CO_AMA = "CO-AMA",
  CO_ANT = "CO-ANT",
  CO_ARA = "CO-ARA",
  CO_ATL = "CO-ATL",
  CO_BOL = "CO-BOL",
  CO_BOY = "CO-BOY",
  CO_CAL = "CO-CAL",
  CO_CAQ = "CO-CAQ",
  CO_CAS = "CO-CAS",
  CO_CAU = "CO-CAU",
  CO_CES = "CO-CES",
  CO_COR = "CO-COR",
  CO_CUN = "CO-CUN",
  CO_CHO = "CO-CHO",
  CO_GUA = "CO-GUA",
  CO_GUV = "CO-GUV",
  CO_HUI = "CO-HUI",
  CO_LAG = "CO-LAG",
  CO_MAG = "CO-MAG",
  CO_MET = "CO-MET",
  CO_NAR = "CO-NAR",
  CO_NSA = "CO-NSA",
  CO_PUT = "CO-PUT",
  CO_QUI = "CO-QUI",
  CO_RIS = "CO-RIS",
  CO_SAP = "CO-SAP",
  CO_SAN = "CO-SAN",
  CO_SUC = "CO-SUC",
  CO_TOL = "CO-TOL",
  CO_VAC = "CO-VAC",
  CO_VAU = "CO-VAU",
  CO_VID = "CO-VID",
  KM_G = "KM-G",
  KM_A = "KM-A",
  KM_M = "KM-M",
  CR_A = "CR-A",
  CR_C = "CR-C",
  CR_G = "CR-G",
  CR_H = "CR-H",
  CR_L = "CR-L",
  CR_P = "CR-P",
  CR_SJ = "CR-SJ",
  CI_AB = "CI-AB",
  CI_BS = "CI-BS",
  CI_CM = "CI-CM",
  CI_DN = "CI-DN",
  CI_GD = "CI-GD",
  CI_LC = "CI-LC",
  CI_LG = "CI-LG",
  CI_MG = "CI-MG",
  CI_SM = "CI-SM",
  CI_SV = "CI-SV",
  CI_VB = "CI-VB",
  CI_WR = "CI-WR",
  CI_YM = "CI-YM",
  CI_ZZ = "CI-ZZ",
  HR_21 = "HR-21",
  HR_07 = "HR-07",
  HR_12 = "HR-12",
  HR_19 = "HR-19",
  HR_18 = "HR-18",
  HR_04 = "HR-04",
  HR_06 = "HR-06",
  HR_02 = "HR-02",
  HR_09 = "HR-09",
  HR_20 = "HR-20",
  HR_14 = "HR-14",
  HR_11 = "HR-11",
  HR_08 = "HR-08",
  HR_03 = "HR-03",
  HR_17 = "HR-17",
  HR_15 = "HR-15",
  HR_05 = "HR-05",
  HR_10 = "HR-10",
  HR_16 = "HR-16",
  HR_13 = "HR-13",
  HR_01 = "HR-01",
  CU_15 = "CU-15",
  CU_09 = "CU-09",
  CU_08 = "CU-08",
  CU_06 = "CU-06",
  CU_12 = "CU-12",
  CU_14 = "CU-14",
  CU_11 = "CU-11",
  CU_03 = "CU-03",
  CU_10 = "CU-10",
  CU_04 = "CU-04",
  CU_16 = "CU-16",
  CU_01 = "CU-01",
  CU_07 = "CU-07",
  CU_13 = "CU-13",
  CU_05 = "CU-05",
  CU_99 = "CU-99",
  CY_04 = "CY-04",
  CY_06 = "CY-06",
  CY_03 = "CY-03",
  CY_01 = "CY-01",
  CY_02 = "CY-02",
  CY_05 = "CY-05",
  CZ_201 = "CZ-201",
  CZ_202 = "CZ-202",
  CZ_641 = "CZ-641",
  CZ_642 = "CZ-642",
  CZ_643 = "CZ-643",
  CZ_801 = "CZ-801",
  CZ_644 = "CZ-644",
  CZ_511 = "CZ-511",
  CZ_311 = "CZ-311",
  CZ_312 = "CZ-312",
  CZ_421 = "CZ-421",
  CZ_321 = "CZ-321",
  CZ_802 = "CZ-802",
  CZ_631 = "CZ-631",
  CZ_645 = "CZ-645",
  CZ_521 = "CZ-521",
  CZ_411 = "CZ-411",
  CZ_422 = "CZ-422",
  CZ_531 = "CZ-531",
  CZ_512 = "CZ-512",
  CZ_711 = "CZ-711",
  CZ_522 = "CZ-522",
  CZ_632 = "CZ-632",
  CZ_313 = "CZ-313",
  CZ_412 = "CZ-412",
  CZ_803 = "CZ-803",
  CZ_203 = "CZ-203",
  CZ_322 = "CZ-322",
  CZ_204 = "CZ-204",
  CZ_721 = "CZ-721",
  CZ_205 = "CZ-205",
  CZ_513 = "CZ-513",
  CZ_423 = "CZ-423",
  CZ_424 = "CZ-424",
  CZ_206 = "CZ-206",
  CZ_207 = "CZ-207",
  CZ_425 = "CZ-425",
  CZ_523 = "CZ-523",
  CZ_804 = "CZ-804",
  CZ_208 = "CZ-208",
  CZ_712 = "CZ-712",
  CZ_805 = "CZ-805",
  CZ_806 = "CZ-806",
  CZ_532 = "CZ-532",
  CZ_633 = "CZ-633",
  CZ_314 = "CZ-314",
  CZ_324 = "CZ-324",
  CZ_323 = "CZ-323",
  CZ_325 = "CZ-325",
  CZ_209 = "CZ-209",
  CZ_20A = "CZ-20A",
  CZ_315 = "CZ-315",
  CZ_713 = "CZ-713",
  CZ_714 = "CZ-714",
  CZ_20B = "CZ-20B",
  CZ_20C = "CZ-20C",
  CZ_326 = "CZ-326",
  CZ_524 = "CZ-524",
  CZ_514 = "CZ-514",
  CZ_413 = "CZ-413",
  CZ_316 = "CZ-316",
  CZ_533 = "CZ-533",
  CZ_715 = "CZ-715",
  CZ_317 = "CZ-317",
  CZ_327 = "CZ-327",
  CZ_426 = "CZ-426",
  CZ_525 = "CZ-525",
  CZ_634 = "CZ-634",
  CZ_722 = "CZ-722",
  CZ_427 = "CZ-427",
  CZ_534 = "CZ-534",
  CZ_723 = "CZ-723",
  CZ_646 = "CZ-646",
  CZ_724 = "CZ-724",
  CZ_647 = "CZ-647",
  CZ_635 = "CZ-635",
  DK_84 = "DK-84",
  DK_82 = "DK-82",
  DK_81 = "DK-81",
  DK_85 = "DK-85",
  DK_83 = "DK-83",
  DJ_AS = "DJ-AS",
  DJ_AR = "DJ-AR",
  DJ_DI = "DJ-DI",
  DJ_OB = "DJ-OB",
  DJ_TA = "DJ-TA",
  DJ_DJ = "DJ-DJ",
  DM_02 = "DM-02",
  DM_03 = "DM-03",
  DM_04 = "DM-04",
  DM_05 = "DM-05",
  DM_06 = "DM-06",
  DM_07 = "DM-07",
  DM_08 = "DM-08",
  DM_09 = "DM-09",
  DM_10 = "DM-10",
  DM_11 = "DM-11",
  DO_33 = "DO-33",
  DO_34 = "DO-34",
  DO_35 = "DO-35",
  DO_36 = "DO-36",
  DO_37 = "DO-37",
  DO_38 = "DO-38",
  DO_39 = "DO-39",
  DO_40 = "DO-40",
  DO_41 = "DO-41",
  DO_42 = "DO-42",
  CD_KN = "CD-KN",
  CD_BC = "CD-BC",
  CD_EQ = "CD-EQ",
  CD_KE = "CD-KE",
  CD_MA = "CD-MA",
  CD_NK = "CD-NK",
  CD_SK = "CD-SK",
  CD_BU = "CD-BU",
  CD_HK = "CD-HK",
  CD_HL = "CD-HL",
  CD_HU = "CD-HU",
  CD_IT = "CD-IT",
  CD_KC = "CD-KC",
  CD_KG = "CD-KG",
  CD_KL = "CD-KL",
  CD_KS = "CD-KS",
  CD_LO = "CD-LO",
  CD_LU = "CD-LU",
  CD_MN = "CD-MN",
  CD_MO = "CD-MO",
  CD_NU = "CD-NU",
  CD_SA = "CD-SA",
  CD_SU = "CD-SU",
  CD_TA = "CD-TA",
  CD_TO = "CD-TO",
  CD_TU = "CD-TU",
  EC_A = "EC-A",
  EC_B = "EC-B",
  EC_F = "EC-F",
  EC_C = "EC-C",
  EC_H = "EC-H",
  EC_X = "EC-X",
  EC_O = "EC-O",
  EC_E = "EC-E",
  EC_W = "EC-W",
  EC_G = "EC-G",
  EC_I = "EC-I",
  EC_L = "EC-L",
  EC_R = "EC-R",
  EC_M = "EC-M",
  EC_S = "EC-S",
  EC_N = "EC-N",
  EC_D = "EC-D",
  EC_Y = "EC-Y",
  EC_P = "EC-P",
  EC_SE = "EC-SE",
  EC_SD = "EC-SD",
  EC_U = "EC-U",
  EC_T = "EC-T",
  EC_Z = "EC-Z",
  EG_DK = "EG-DK",
  EG_BA = "EG-BA",
  EG_BH = "EG-BH",
  EG_FYM = "EG-FYM",
  EG_GH = "EG-GH",
  EG_ALX = "EG-ALX",
  EG_IS = "EG-IS",
  EG_GZ = "EG-GZ",
  EG_MNF = "EG-MNF",
  EG_MN = "EG-MN",
  EG_C = "EG-C",
  EG_KB = "EG-KB",
  EG_LX = "EG-LX",
  EG_WAD = "EG-WAD",
  EG_SUZ = "EG-SUZ",
  EG_SHR = "EG-SHR",
  EG_ASN = "EG-ASN",
  EG_AST = "EG-AST",
  EG_BNS = "EG-BNS",
  EG_PTS = "EG-PTS",
  EG_DT = "EG-DT",
  EG_JS = "EG-JS",
  EG_KFS = "EG-KFS",
  EG_MT = "EG-MT",
  EG_KN = "EG-KN",
  EG_SIN = "EG-SIN",
  EG_SHG = "EG-SHG",
  SV_AH = "SV-AH",
  SV_CA = "SV-CA",
  SV_CH = "SV-CH",
  SV_CU = "SV-CU",
  SV_LI = "SV-LI",
  SV_PA = "SV-PA",
  SV_UN = "SV-UN",
  SV_MO = "SV-MO",
  SV_SM = "SV-SM",
  SV_SS = "SV-SS",
  SV_SV = "SV-SV",
  SV_SA = "SV-SA",
  SV_SO = "SV-SO",
  SV_US = "SV-US",
  GQ_C = "GQ-C",
  GQ_I = "GQ-I",
  ER_MA = "ER-MA",
  ER_DU = "ER-DU",
  ER_AN = "ER-AN",
  ER_DK = "ER-DK",
  ER_GB = "ER-GB",
  ER_SK = "ER-SK",
  EE_37 = "EE-37",
  EE_39 = "EE-39",
  EE_45 = "EE-45",
  EE_50 = "EE-50",
  EE_52 = "EE-52",
  EE_56 = "EE-56",
  EE_60 = "EE-60",
  EE_64 = "EE-64",
  EE_68 = "EE-68",
  EE_71 = "EE-71",
  EE_74 = "EE-74",
  EE_79 = "EE-79",
  EE_81 = "EE-81",
  EE_84 = "EE-84",
  EE_87 = "EE-87",
  SZ_HH = "SZ-HH",
  SZ_LU = "SZ-LU",
  SZ_MA = "SZ-MA",
  SZ_SH = "SZ-SH",
  ET_AA = "ET-AA",
  ET_DD = "ET-DD",
  ET_AF = "ET-AF",
  ET_AM = "ET-AM",
  ET_BE = "ET-BE",
  ET_GA = "ET-GA",
  ET_HA = "ET-HA",
  ET_OR = "ET-OR",
  ET_SO = "ET-SO",
  ET_TI = "ET-TI",
  ET_SN = "ET-SN",
  FK_FK = "FK-FK",
  FJ_C = "FJ-C",
  FJ_E = "FJ-E",
  FJ_N = "FJ-N",
  FJ_W = "FJ-W",
  FJ_R = "FJ-R",
  FJ_01 = "FJ-01",
  FJ_02 = "FJ-02",
  FJ_03 = "FJ-03",
  FJ_04 = "FJ-04",
  FJ_05 = "FJ-05",
  FJ_06 = "FJ-06",
  FJ_07 = "FJ-07",
  FJ_08 = "FJ-08",
  FJ_09 = "FJ-09",
  FJ_10 = "FJ-10",
  FJ_11 = "FJ-11",
  FJ_12 = "FJ-12",
  FJ_13 = "FJ-13",
  FJ_14 = "FJ-14",
  FI_01 = "FI-01",
  FI_02 = "FI-02",
  FI_03 = "FI-03",
  FI_04 = "FI-04",
  FI_05 = "FI-05",
  FI_06 = "FI-06",
  FI_07 = "FI-07",
  FI_08 = "FI-08",
  FI_09 = "FI-09",
  FI_10 = "FI-10",
  FI_11 = "FI-11",
  FI_12 = "FI-12",
  FI_13 = "FI-13",
  FI_14 = "FI-14",
  FI_15 = "FI-15",
  FI_16 = "FI-16",
  FI_17 = "FI-17",
  FI_18 = "FI-18",
  FI_19 = "FI-19",
  FR_ARA = "FR-ARA",
  FR_BFC = "FR-BFC",
  FR_BRE = "FR-BRE",
  FR_CVL = "FR-CVL",
  FR_20R = "FR-20R",
  FR_GES = "FR-GES",
  FR_GP = "FR-GP",
  FR_GF = "FR-GF",
  FR_HDF = "FR-HDF",
  FR_IDF = "FR-IDF",
  FR_MQ = "FR-MQ",
  FR_YT = "FR-YT",
  FR_NOR = "FR-NOR",
  FR_NAQ = "FR-NAQ",
  FR_OCC = "FR-OCC",
  FR_PDL = "FR-PDL",
  FR_PAC = "FR-PAC",
  FR_RE = "FR-RE",
  TF_TF = "TF-TF",
  GA_1 = "GA-1",
  GA_2 = "GA-2",
  GA_3 = "GA-3",
  GA_4 = "GA-4",
  GA_5 = "GA-5",
  GA_6 = "GA-6",
  GA_7 = "GA-7",
  GA_8 = "GA-8",
  GA_9 = "GA-9",
  GM_B = "GM-B",
  GM_M = "GM-M",
  GM_L = "GM-L",
  GM_N = "GM-N",
  GM_U = "GM-U",
  GM_W = "GM-W",
  GE_AB = "GE-AB",
  GE_AJ = "GE-AJ",
  GE_TB = "GE-TB",
  GE_GU = "GE-GU",
  GE_IM = "GE-IM",
  GE_KA = "GE-KA",
  GE_KK = "GE-KK",
  GE_MM = "GE-MM",
  GE_RL = "GE-RL",
  GE_SZ = "GE-SZ",
  GE_SJ = "GE-SJ",
  GE_SK = "GE-SK",
  DE_BW = "DE-BW",
  DE_BY = "DE-BY",
  DE_BE = "DE-BE",
  DE_BB = "DE-BB",
  DE_HB = "DE-HB",
  DE_HH = "DE-HH",
  DE_HE = "DE-HE",
  DE_MV = "DE-MV",
  DE_NI = "DE-NI",
  DE_NW = "DE-NW",
  DE_RP = "DE-RP",
  DE_SL = "DE-SL",
  DE_SN = "DE-SN",
  DE_ST = "DE-ST",
  DE_SH = "DE-SH",
  DE_TH = "DE-TH",
  GH_AF = "GH-AF",
  GH_AH = "GH-AH",
  GH_BO = "GH-BO",
  GH_BE = "GH-BE",
  GH_CP = "GH-CP",
  GH_EP = "GH-EP",
  GH_AA = "GH-AA",
  GH_NE = "GH-NE",
  GH_NP = "GH-NP",
  GH_OT = "GH-OT",
  GH_SV = "GH-SV",
  GH_UE = "GH-UE",
  GH_UW = "GH-UW",
  GH_TV = "GH-TV",
  GH_WP = "GH-WP",
  GH_WN = "GH-WN",
  GH_BA = "GH-BA",
  GR_A = "GR-A",
  GR_I = "GR-I",
  GR_G = "GR-G",
  GR_C = "GR-C",
  GR_F = "GR-F",
  GR_D = "GR-D",
  GR_B = "GR-B",
  GR_M = "GR-M",
  GR_L = "GR-L",
  GR_J = "GR-J",
  GR_H = "GR-H",
  GR_E = "GR-E",
  GR_K = "GR-K",
  GL_AV = "GL-AV",
  GL_KU = "GL-KU",
  GL_QT = "GL-QT",
  GL_SM = "GL-SM",
  GL_QE = "GL-QE",
  GD_01 = "GD-01",
  GD_02 = "GD-02",
  GD_03 = "GD-03",
  GD_04 = "GD-04",
  GD_05 = "GD-05",
  GD_06 = "GD-06",
  GD_10 = "GD-10",
  GT_AV = "GT-AV",
  GT_BV = "GT-BV",
  GT_CM = "GT-CM",
  GT_CQ = "GT-CQ",
  GT_PR = "GT-PR",
  GT_ES = "GT-ES",
  GT_GU = "GT-GU",
  GT_HU = "GT-HU",
  GT_IZ = "GT-IZ",
  GT_JA = "GT-JA",
  GT_JU = "GT-JU",
  GT_PE = "GT-PE",
  GT_QZ = "GT-QZ",
  GT_QC = "GT-QC",
  GT_RE = "GT-RE",
  GT_SA = "GT-SA",
  GT_SM = "GT-SM",
  GT_SR = "GT-SR",
  GT_SO = "GT-SO",
  GT_SU = "GT-SU",
  GT_TO = "GT-TO",
  GT_ZA = "GT-ZA",
  GN_B = "GN-B",
  GN_F = "GN-F",
  GN_K = "GN-K",
  GN_D = "GN-D",
  GN_L = "GN-L",
  GN_M = "GN-M",
  GN_N = "GN-N",
  GN_C = "GN-C",
  GN_BE = "GN-BE",
  GN_BF = "GN-BF",
  GN_BK = "GN-BK",
  GN_CO = "GN-CO",
  GN_DB = "GN-DB",
  GN_DL = "GN-DL",
  GN_DI = "GN-DI",
  GN_DU = "GN-DU",
  GN_FA = "GN-FA",
  GN_FO = "GN-FO",
  GN_FR = "GN-FR",
  GN_GA = "GN-GA",
  GN_GU = "GN-GU",
  GN_KA = "GN-KA",
  GN_KE = "GN-KE",
  GN_KD = "GN-KD",
  GN_KS = "GN-KS",
  GN_KB = "GN-KB",
  GN_KN = "GN-KN",
  GN_KO = "GN-KO",
  GN_LA = "GN-LA",
  GN_LE = "GN-LE",
  GN_LO = "GN-LO",
  GN_MC = "GN-MC",
  GN_ML = "GN-ML",
  GN_MM = "GN-MM",
  GN_MD = "GN-MD",
  GN_NZ = "GN-NZ",
  GN_PI = "GN-PI",
  GN_SI = "GN-SI",
  GN_TE = "GN-TE",
  GN_TO = "GN-TO",
  GN_YO = "GN-YO",
  GW_L = "GW-L",
  GW_N = "GW-N",
  GW_S = "GW-S",
  GY_BA = "GY-BA",
  GY_CU = "GY-CU",
  GY_DE = "GY-DE",
  GY_EB = "GY-EB",
  GY_ES = "GY-ES",
  GY_MA = "GY-MA",
  GY_PM = "GY-PM",
  GY_PT = "GY-PT",
  GY_UD = "GY-UD",
  GY_UT = "GY-UT",
  HT_AR = "HT-AR",
  HT_CE = "HT-CE",
  HT_GA = "HT-GA",
  HT_NI = "HT-NI",
  HT_ND = "HT-ND",
  HT_NE = "HT-NE",
  HT_NO = "HT-NO",
  HT_OU = "HT-OU",
  HT_SD = "HT-SD",
  HT_SE = "HT-SE",
  HM_HM = "HM-HM",
  HN_AT = "HN-AT",
  HN_CH = "HN-CH",
  HN_CL = "HN-CL",
  HN_CM = "HN-CM",
  HN_CP = "HN-CP",
  HN_CR = "HN-CR",
  HN_EP = "HN-EP",
  HN_FM = "HN-FM",
  HN_GD = "HN-GD",
  HN_IN = "HN-IN",
  HN_IB = "HN-IB",
  HN_LP = "HN-LP",
  HN_LE = "HN-LE",
  HN_OC = "HN-OC",
  HN_OL = "HN-OL",
  HN_SB = "HN-SB",
  HN_VA = "HN-VA",
  HN_YO = "HN-YO",
  HU_BU = "HU-BU",
  HU_BK = "HU-BK",
  HU_BA = "HU-BA",
  HU_BE = "HU-BE",
  HU_BZ = "HU-BZ",
  HU_CS = "HU-CS",
  HU_FE = "HU-FE",
  HU_GS = "HU-GS",
  HU_HB = "HU-HB",
  HU_HE = "HU-HE",
  HU_JN = "HU-JN",
  HU_KE = "HU-KE",
  HU_NO = "HU-NO",
  HU_PE = "HU-PE",
  HU_SO = "HU-SO",
  HU_SZ = "HU-SZ",
  HU_TO = "HU-TO",
  HU_VA = "HU-VA",
  HU_VE = "HU-VE",
  HU_ZA = "HU-ZA",
  HU_BC = "HU-BC",
  HU_DE = "HU-DE",
  HU_DU = "HU-DU",
  HU_EG = "HU-EG",
  HU_ER = "HU-ER",
  HU_GY = "HU-GY",
  HU_HV = "HU-HV",
  HU_KV = "HU-KV",
  HU_KM = "HU-KM",
  HU_MI = "HU-MI",
  HU_NK = "HU-NK",
  HU_NY = "HU-NY",
  HU_PS = "HU-PS",
  HU_ST = "HU-ST",
  HU_SN = "HU-SN",
  HU_SD = "HU-SD",
  HU_SF = "HU-SF",
  HU_SS = "HU-SS",
  HU_SK = "HU-SK",
  HU_SH = "HU-SH",
  HU_TB = "HU-TB",
  HU_VM = "HU-VM",
  HU_ZE = "HU-ZE",
  IS_1 = "IS-1",
  IS_2 = "IS-2",
  IS_3 = "IS-3",
  IS_4 = "IS-4",
  IS_5 = "IS-5",
  IS_6 = "IS-6",
  IS_7 = "IS-7",
  IS_8 = "IS-8",
  IN_AP = "IN-AP",
  IN_AR = "IN-AR",
  IN_AS = "IN-AS",
  IN_BR = "IN-BR",
  IN_CT = "IN-CT",
  IN_GA = "IN-GA",
  IN_GJ = "IN-GJ",
  IN_HR = "IN-HR",
  IN_HP = "IN-HP",
  IN_JH = "IN-JH",
  IN_KA = "IN-KA",
  IN_KL = "IN-KL",
  IN_MP = "IN-MP",
  IN_MH = "IN-MH",
  IN_MN = "IN-MN",
  IN_ML = "IN-ML",
  IN_MZ = "IN-MZ",
  IN_NL = "IN-NL",
  IN_OR = "IN-OR",
  IN_PB = "IN-PB",
  IN_RJ = "IN-RJ",
  IN_SK = "IN-SK",
  IN_TN = "IN-TN",
  IN_TG = "IN-TG",
  IN_TR = "IN-TR",
  IN_UT = "IN-UT",
  IN_UP = "IN-UP",
  IN_WB = "IN-WB",
  IN_AN = "IN-AN",
  IN_CH = "IN-CH",
  IN_DH = "IN-DH",
  IN_DL = "IN-DL",
  IN_JK = "IN-JK",
  IN_LA = "IN-LA",
  IN_LD = "IN-LD",
  IN_PY = "IN-PY",
  ID_JW = "ID-JW",
  ID_KA = "ID-KA",
  ID_ML = "ID-ML",
  ID_NU = "ID-NU",
  ID_PP = "ID-PP",
  ID_SL = "ID-SL",
  ID_SM = "ID-SM",
  IR_30 = "IR-30",
  IR_24 = "IR-24",
  IR_04 = "IR-04",
  IR_03 = "IR-03",
  IR_18 = "IR-18",
  IR_14 = "IR-14",
  IR_10 = "IR-10",
  IR_07 = "IR-07",
  IR_01 = "IR-01",
  IR_27 = "IR-27",
  IR_13 = "IR-13",
  IR_22 = "IR-22",
  IR_16 = "IR-16",
  IR_08 = "IR-08",
  IR_05 = "IR-05",
  IR_29 = "IR-29",
  IR_09 = "IR-09",
  IR_28 = "IR-28",
  IR_06 = "IR-06",
  IR_17 = "IR-17",
  IR_12 = "IR-12",
  IR_15 = "IR-15",
  IR_00 = "IR-00",
  IR_02 = "IR-02",
  IR_26 = "IR-26",
  IR_25 = "IR-25",
  IR_20 = "IR-20",
  IR_11 = "IR-11",
  IR_23 = "IR-23",
  IR_21 = "IR-21",
  IR_19 = "IR-19",
  IQ_AN = "IQ-AN",
  IQ_BA = "IQ-BA",
  IQ_MU = "IQ-MU",
  IQ_QA = "IQ-QA",
  IQ_NA = "IQ-NA",
  IQ_AR = "IQ-AR",
  IQ_SU = "IQ-SU",
  IQ_BB = "IQ-BB",
  IQ_BG = "IQ-BG",
  IQ_DA = "IQ-DA",
  IQ_DQ = "IQ-DQ",
  IQ_DI = "IQ-DI",
  IQ_KA = "IQ-KA",
  IQ_KI = "IQ-KI",
  IQ_MA = "IQ-MA",
  IQ_NI = "IQ-NI",
  IQ_SD = "IQ-SD",
  IQ_WA = "IQ-WA",
  IQ_HA = "IQ-HA",
  IE_C = "IE-C",
  IE_L = "IE-L",
  IE_M = "IE-M",
  IE_U = "IE-U",
  IE_CW = "IE-CW",
  IE_CN = "IE-CN",
  IE_CE = "IE-CE",
  IE_CO = "IE-CO",
  IE_DL = "IE-DL",
  IE_D = "IE-D",
  IE_G = "IE-G",
  IE_KY = "IE-KY",
  IE_KE = "IE-KE",
  IE_KK = "IE-KK",
  IE_LS = "IE-LS",
  IE_LM = "IE-LM",
  IE_LK = "IE-LK",
  IE_LD = "IE-LD",
  IE_LH = "IE-LH",
  IE_MO = "IE-MO",
  IE_MH = "IE-MH",
  IE_MN = "IE-MN",
  IE_OY = "IE-OY",
  IE_RN = "IE-RN",
  IE_SO = "IE-SO",
  IE_TA = "IE-TA",
  IE_WD = "IE-WD",
  IE_WH = "IE-WH",
  IE_WX = "IE-WX",
  IE_WW = "IE-WW",
  IL_D = "IL-D",
  IL_M = "IL-M",
  IL_Z = "IL-Z",
  IL_HA = "IL-HA",
  IL_TA = "IL-TA",
  IL_JM = "IL-JM",
  JM_13 = "JM-13",
  JM_09 = "JM-09",
  JM_01 = "JM-01",
  JM_12 = "JM-12",
  JM_04 = "JM-04",
  JM_02 = "JM-02",
  JM_06 = "JM-06",
  JM_14 = "JM-14",
  JM_11 = "JM-11",
  JM_08 = "JM-08",
  JM_05 = "JM-05",
  JM_03 = "JM-03",
  JM_07 = "JM-07",
  JM_10 = "JM-10",
  JP_23 = "JP-23",
  JP_05 = "JP-05",
  JP_02 = "JP-02",
  JP_38 = "JP-38",
  JP_21 = "JP-21",
  JP_10 = "JP-10",
  JP_34 = "JP-34",
  JP_01 = "JP-01",
  JP_18 = "JP-18",
  JP_40 = "JP-40",
  JP_07 = "JP-07",
  JP_28 = "JP-28",
  JP_08 = "JP-08",
  JP_17 = "JP-17",
  JP_03 = "JP-03",
  JP_37 = "JP-37",
  JP_46 = "JP-46",
  JP_14 = "JP-14",
  JP_39 = "JP-39",
  JP_43 = "JP-43",
  JP_26 = "JP-26",
  JP_24 = "JP-24",
  JP_04 = "JP-04",
  JP_45 = "JP-45",
  JP_20 = "JP-20",
  JP_42 = "JP-42",
  JP_29 = "JP-29",
  JP_15 = "JP-15",
  JP_44 = "JP-44",
  JP_33 = "JP-33",
  JP_47 = "JP-47",
  JP_27 = "JP-27",
  JP_41 = "JP-41",
  JP_11 = "JP-11",
  JP_25 = "JP-25",
  JP_32 = "JP-32",
  JP_22 = "JP-22",
  JP_12 = "JP-12",
  JP_09 = "JP-09",
  JP_36 = "JP-36",
  JP_13 = "JP-13",
  JP_31 = "JP-31",
  JP_16 = "JP-16",
  JP_30 = "JP-30",
  JP_06 = "JP-06",
  JP_35 = "JP-35",
  JP_19 = "JP-19",
  JO_AJ = "JO-AJ",
  JO_AQ = "JO-AQ",
  JO_AM = "JO-AM",
  JO_BA = "JO-BA",
  JO_KA = "JO-KA",
  JO_MA = "JO-MA",
  JO_AT = "JO-AT",
  JO_AZ = "JO-AZ",
  JO_IR = "JO-IR",
  JO_JA = "JO-JA",
  JO_MN = "JO-MN",
  JO_MD = "JO-MD",
  KZ_ALA = "KZ-ALA",
  KZ_ALM = "KZ-ALM",
  KZ_AKM = "KZ-AKM",
  KZ_AKT = "KZ-AKT",
  KZ_ATY = "KZ-ATY",
  KZ_ZAP = "KZ-ZAP",
  KZ_MAN = "KZ-MAN",
  KZ_AST = "KZ-AST",
  KZ_PAV = "KZ-PAV",
  KZ_KAR = "KZ-KAR",
  KZ_KUS = "KZ-KUS",
  KZ_KZY = "KZ-KZY",
  KZ_VOS = "KZ-VOS",
  KZ_SHY = "KZ-SHY",
  KZ_SEV = "KZ-SEV",
  KZ_YUZ = "KZ-YUZ",
  KZ_ZHA = "KZ-ZHA",
  KE_01 = "KE-01",
  KE_02 = "KE-02",
  KE_03 = "KE-03",
  KE_04 = "KE-04",
  KE_05 = "KE-05",
  KE_06 = "KE-06",
  KE_07 = "KE-07",
  KE_08 = "KE-08",
  KE_09 = "KE-09",
  KE_10 = "KE-10",
  KE_11 = "KE-11",
  KE_12 = "KE-12",
  KE_13 = "KE-13",
  KE_14 = "KE-14",
  KE_15 = "KE-15",
  KE_16 = "KE-16",
  KE_17 = "KE-17",
  KE_18 = "KE-18",
  KE_19 = "KE-19",
  KE_20 = "KE-20",
  KE_21 = "KE-21",
  KE_22 = "KE-22",
  KE_23 = "KE-23",
  KE_24 = "KE-24",
  KE_25 = "KE-25",
  KE_26 = "KE-26",
  KE_27 = "KE-27",
  KE_28 = "KE-28",
  KE_29 = "KE-29",
  KE_30 = "KE-30",
  KE_31 = "KE-31",
  KE_32 = "KE-32",
  KE_33 = "KE-33",
  KE_34 = "KE-34",
  KE_35 = "KE-35",
  KE_36 = "KE-36",
  KE_37 = "KE-37",
  KE_38 = "KE-38",
  KE_39 = "KE-39",
  KE_40 = "KE-40",
  KE_41 = "KE-41",
  KE_42 = "KE-42",
  KE_43 = "KE-43",
  KE_44 = "KE-44",
  KE_45 = "KE-45",
  KE_46 = "KE-46",
  KE_47 = "KE-47",
  KI_G = "KI-G",
  KI_L = "KI-L",
  KI_P = "KI-P",
  KW_AH = "KW-AH",
  KW_FA = "KW-FA",
  KW_JA = "KW-JA",
  KW_KU = "KW-KU",
  KW_HA = "KW-HA",
  KW_MU = "KW-MU",
  LA_VT = "LA-VT",
  LA_AT = "LA-AT",
  LA_BK = "LA-BK",
  LA_BL = "LA-BL",
  LA_CH = "LA-CH",
  LA_HO = "LA-HO",
  LA_KH = "LA-KH",
  LA_LM = "LA-LM",
  LA_LP = "LA-LP",
  LA_OU = "LA-OU",
  LA_PH = "LA-PH",
  LA_SL = "LA-SL",
  LA_SV = "LA-SV",
  LA_VI = "LA-VI",
  LA_XA = "LA-XA",
  LA_XE = "LA-XE",
  LA_XI = "LA-XI",
  LA_XS = "LA-XS",
  LV_001 = "LV-001",
  LV_002 = "LV-002",
  LV_003 = "LV-003",
  LV_004 = "LV-004",
  LV_005 = "LV-005",
  LV_006 = "LV-006",
  LV_007 = "LV-007",
  LV_008 = "LV-008",
  LV_009 = "LV-009",
  LV_010 = "LV-010",
  LV_011 = "LV-011",
  LV_012 = "LV-012",
  LV_013 = "LV-013",
  LV_014 = "LV-014",
  LV_015 = "LV-015",
  LV_016 = "LV-016",
  LV_017 = "LV-017",
  LV_018 = "LV-018",
  LV_019 = "LV-019",
  LV_020 = "LV-020",
  LV_021 = "LV-021",
  LV_022 = "LV-022",
  LV_023 = "LV-023",
  LV_024 = "LV-024",
  LV_025 = "LV-025",
  LV_026 = "LV-026",
  LV_027 = "LV-027",
  LV_028 = "LV-028",
  LV_029 = "LV-029",
  LV_030 = "LV-030",
  LV_031 = "LV-031",
  LV_032 = "LV-032",
  LV_033 = "LV-033",
  LV_034 = "LV-034",
  LV_035 = "LV-035",
  LV_036 = "LV-036",
  LV_037 = "LV-037",
  LV_038 = "LV-038",
  LV_039 = "LV-039",
  LV_040 = "LV-040",
  LV_041 = "LV-041",
  LV_042 = "LV-042",
  LV_043 = "LV-043",
  LV_044 = "LV-044",
  LV_045 = "LV-045",
  LV_046 = "LV-046",
  LV_047 = "LV-047",
  LV_048 = "LV-048",
  LV_049 = "LV-049",
  LV_050 = "LV-050",
  LV_051 = "LV-051",
  LV_052 = "LV-052",
  LV_053 = "LV-053",
  LV_054 = "LV-054",
  LV_055 = "LV-055",
  LV_056 = "LV-056",
  LV_057 = "LV-057",
  LV_058 = "LV-058",
  LV_059 = "LV-059",
  LV_060 = "LV-060",
  LV_061 = "LV-061",
  LV_062 = "LV-062",
  LV_063 = "LV-063",
  LV_064 = "LV-064",
  LV_065 = "LV-065",
  LV_066 = "LV-066",
  LV_067 = "LV-067",
  LV_068 = "LV-068",
  LV_069 = "LV-069",
  LV_070 = "LV-070",
  LV_071 = "LV-071",
  LV_072 = "LV-072",
  LV_073 = "LV-073",
  LV_074 = "LV-074",
  LV_075 = "LV-075",
  LV_076 = "LV-076",
  LV_077 = "LV-077",
  LV_078 = "LV-078",
  LV_079 = "LV-079",
  LV_080 = "LV-080",
  LV_081 = "LV-081",
  LV_082 = "LV-082",
  LV_083 = "LV-083",
  LV_084 = "LV-084",
  LV_085 = "LV-085",
  LV_086 = "LV-086",
  LV_087 = "LV-087",
  LV_088 = "LV-088",
  LV_089 = "LV-089",
  LV_090 = "LV-090",
  LV_091 = "LV-091",
  LV_092 = "LV-092",
  LV_093 = "LV-093",
  LV_094 = "LV-094",
  LV_095 = "LV-095",
  LV_096 = "LV-096",
  LV_097 = "LV-097",
  LV_098 = "LV-098",
  LV_099 = "LV-099",
  LV_100 = "LV-100",
  LV_101 = "LV-101",
  LV_102 = "LV-102",
  LV_103 = "LV-103",
  LV_104 = "LV-104",
  LV_105 = "LV-105",
  LV_106 = "LV-106",
  LV_107 = "LV-107",
  LV_108 = "LV-108",
  LV_109 = "LV-109",
  LV_110 = "LV-110",
  LV_DGV = "LV-DGV",
  LV_JEL = "LV-JEL",
  LV_JKB = "LV-JKB",
  LV_JUR = "LV-JUR",
  LV_LPX = "LV-LPX",
  LV_REZ = "LV-REZ",
  LV_RIX = "LV-RIX",
  LV_VMR = "LV-VMR",
  LV_VEN = "LV-VEN",
  LB_AK = "LB-AK",
  LB_BH = "LB-BH",
  LB_BI = "LB-BI",
  LB_BA = "LB-BA",
  LB_AS = "LB-AS",
  LB_JA = "LB-JA",
  LB_JL = "LB-JL",
  LB_NA = "LB-NA",
  LS_D = "LS-D",
  LS_B = "LS-B",
  LS_C = "LS-C",
  LS_E = "LS-E",
  LS_A = "LS-A",
  LS_F = "LS-F",
  LS_J = "LS-J",
  LS_H = "LS-H",
  LS_G = "LS-G",
  LS_K = "LS-K",
  LR_BM = "LR-BM",
  LR_BG = "LR-BG",
  LR_GP = "LR-GP",
  LR_GB = "LR-GB",
  LR_CM = "LR-CM",
  LR_GG = "LR-GG",
  LR_GK = "LR-GK",
  LR_LO = "LR-LO",
  LR_MG = "LR-MG",
  LR_MY = "LR-MY",
  LR_MO = "LR-MO",
  LR_NI = "LR-NI",
  LR_RI = "LR-RI",
  LR_RG = "LR-RG",
  LR_SI = "LR-SI",
  LY_BU = "LY-BU",
  LY_JA = "LY-JA",
  LY_JG = "LY-JG",
  LY_JI = "LY-JI",
  LY_JU = "LY-JU",
  LY_KF = "LY-KF",
  LY_MJ = "LY-MJ",
  LY_MB = "LY-MB",
  LY_WA = "LY-WA",
  LY_NQ = "LY-NQ",
  LY_ZA = "LY-ZA",
  LY_BA = "LY-BA",
  LY_DR = "LY-DR",
  LY_GT = "LY-GT",
  LY_MI = "LY-MI",
  LY_MQ = "LY-MQ",
  LY_NL = "LY-NL",
  LY_SB = "LY-SB",
  LY_SR = "LY-SR",
  LY_TB = "LY-TB",
  LY_WD = "LY-WD",
  LY_WS = "LY-WS",
  LI_01 = "LI-01",
  LI_02 = "LI-02",
  LI_03 = "LI-03",
  LI_04 = "LI-04",
  LI_05 = "LI-05",
  LI_06 = "LI-06",
  LI_07 = "LI-07",
  LI_08 = "LI-08",
  LI_09 = "LI-09",
  LI_10 = "LI-10",
  LI_11 = "LI-11",
  LT_AL = "LT-AL",
  LT_KU = "LT-KU",
  LT_KL = "LT-KL",
  LT_MR = "LT-MR",
  LT_PN = "LT-PN",
  LT_SA = "LT-SA",
  LT_TA = "LT-TA",
  LT_TE = "LT-TE",
  LT_UT = "LT-UT",
  LT_VL = "LT-VL",
  LU_CA = "LU-CA",
  LU_CL = "LU-CL",
  LU_DI = "LU-DI",
  LU_EC = "LU-EC",
  LU_ES = "LU-ES",
  LU_GR = "LU-GR",
  LU_LU = "LU-LU",
  LU_ME = "LU-ME",
  LU_RD = "LU-RD",
  LU_RM = "LU-RM",
  LU_VD = "LU-VD",
  LU_WI = "LU-WI",
  MG_T = "MG-T",
  MG_D = "MG-D",
  MG_F = "MG-F",
  MG_M = "MG-M",
  MG_A = "MG-A",
  MG_U = "MG-U",
  MW_C = "MW-C",
  MW_N = "MW-N",
  MW_S = "MW-S",
  MW_BA = "MW-BA",
  MW_BL = "MW-BL",
  MW_CK = "MW-CK",
  MW_CR = "MW-CR",
  MW_CT = "MW-CT",
  MW_DE = "MW-DE",
  MW_DO = "MW-DO",
  MW_KR = "MW-KR",
  MW_KS = "MW-KS",
  MW_LK = "MW-LK",
  MW_LI = "MW-LI",
  MW_MH = "MW-MH",
  MW_MG = "MW-MG",
  MW_MC = "MW-MC",
  MW_MU = "MW-MU",
  MW_MW = "MW-MW",
  MW_MZ = "MW-MZ",
  MW_NE = "MW-NE",
  MW_NB = "MW-NB",
  MW_NK = "MW-NK",
  MW_NS = "MW-NS",
  MW_NU = "MW-NU",
  MW_NI = "MW-NI",
  MW_PH = "MW-PH",
  MW_RU = "MW-RU",
  MW_SA = "MW-SA",
  MW_TH = "MW-TH",
  MW_ZO = "MW-ZO",
  MY_14 = "MY-14",
  MY_15 = "MY-15",
  MY_16 = "MY-16",
  MY_01 = "MY-01",
  MY_02 = "MY-02",
  MY_03 = "MY-03",
  MY_04 = "MY-04",
  MY_05 = "MY-05",
  MY_06 = "MY-06",
  MY_08 = "MY-08",
  MY_09 = "MY-09",
  MY_07 = "MY-07",
  MY_12 = "MY-12",
  MY_13 = "MY-13",
  MY_10 = "MY-10",
  MY_11 = "MY-11",
  MV_01 = "MV-01",
  MV_MLE = "MV-MLE",
  MV_02 = "MV-02",
  MV_00 = "MV-00",
  MV_20 = "MV-20",
  MV_17 = "MV-17",
  MV_14 = "MV-14",
  MV_27 = "MV-27",
  MV_28 = "MV-28",
  MV_29 = "MV-29",
  MV_07 = "MV-07",
  MV_23 = "MV-23",
  MV_26 = "MV-26",
  MV_05 = "MV-05",
  MV_03 = "MV-03",
  MV_12 = "MV-12",
  MV_25 = "MV-25",
  MV_13 = "MV-13",
  MV_24 = "MV-24",
  MV_08 = "MV-08",
  MV_04 = "MV-04",
  ML_BKO = "ML-BKO",
  ML_7 = "ML-7",
  ML_1 = "ML-1",
  ML_8 = "ML-8",
  ML_2 = "ML-2",
  ML_9 = "ML-9",
  ML_5 = "ML-5",
  ML_4 = "ML-4",
  ML_3 = "ML-3",
  ML_10 = "ML-10",
  ML_6 = "ML-6",
  MT_01 = "MT-01",
  MT_02 = "MT-02",
  MT_03 = "MT-03",
  MT_04 = "MT-04",
  MT_05 = "MT-05",
  MT_06 = "MT-06",
  MT_07 = "MT-07",
  MT_08 = "MT-08",
  MT_09 = "MT-09",
  MT_10 = "MT-10",
  MT_11 = "MT-11",
  MT_12 = "MT-12",
  MT_13 = "MT-13",
  MT_14 = "MT-14",
  MT_15 = "MT-15",
  MT_16 = "MT-16",
  MT_17 = "MT-17",
  MT_18 = "MT-18",
  MT_19 = "MT-19",
  MT_20 = "MT-20",
  MT_21 = "MT-21",
  MT_22 = "MT-22",
  MT_23 = "MT-23",
  MT_24 = "MT-24",
  MT_25 = "MT-25",
  MT_26 = "MT-26",
  MT_27 = "MT-27",
  MT_28 = "MT-28",
  MT_29 = "MT-29",
  MT_30 = "MT-30",
  MT_31 = "MT-31",
  MT_32 = "MT-32",
  MT_33 = "MT-33",
  MT_34 = "MT-34",
  MT_35 = "MT-35",
  MT_36 = "MT-36",
  MT_37 = "MT-37",
  MT_38 = "MT-38",
  MT_39 = "MT-39",
  MT_40 = "MT-40",
  MT_41 = "MT-41",
  MT_42 = "MT-42",
  MT_43 = "MT-43",
  MT_44 = "MT-44",
  MT_45 = "MT-45",
  MT_46 = "MT-46",
  MT_47 = "MT-47",
  MT_48 = "MT-48",
  MT_49 = "MT-49",
  MT_50 = "MT-50",
  MT_51 = "MT-51",
  MT_52 = "MT-52",
  MT_53 = "MT-53",
  MT_54 = "MT-54",
  MT_55 = "MT-55",
  MT_56 = "MT-56",
  MT_57 = "MT-57",
  MT_58 = "MT-58",
  MT_59 = "MT-59",
  MT_60 = "MT-60",
  MT_61 = "MT-61",
  MT_62 = "MT-62",
  MT_63 = "MT-63",
  MT_64 = "MT-64",
  MT_65 = "MT-65",
  MT_66 = "MT-66",
  MT_67 = "MT-67",
  MT_68 = "MT-68",
  MH_L = "MH-L",
  MH_T = "MH-T",
  MH_ALL = "MH-ALL",
  MH_ALK = "MH-ALK",
  MH_ARN = "MH-ARN",
  MH_AUR = "MH-AUR",
  MH_KIL = "MH-KIL",
  MH_EBO = "MH-EBO",
  MH_ENI = "MH-ENI",
  MH_JAB = "MH-JAB",
  MH_JAL = "MH-JAL",
  MH_KWA = "MH-KWA",
  MH_LAE = "MH-LAE",
  MH_LIB = "MH-LIB",
  MH_LIK = "MH-LIK",
  MH_MAJ = "MH-MAJ",
  MH_MAL = "MH-MAL",
  MH_MEJ = "MH-MEJ",
  MH_MIL = "MH-MIL",
  MH_NMK = "MH-NMK",
  MH_NMU = "MH-NMU",
  MH_RON = "MH-RON",
  MH_UJA = "MH-UJA",
  MH_UTI = "MH-UTI",
  MH_WTH = "MH-WTH",
  MH_WTJ = "MH-WTJ",
  MR_07 = "MR-07",
  MR_03 = "MR-03",
  MR_05 = "MR-05",
  MR_08 = "MR-08",
  MR_04 = "MR-04",
  MR_10 = "MR-10",
  MR_01 = "MR-01",
  MR_02 = "MR-02",
  MR_12 = "MR-12",
  MR_14 = "MR-14",
  MR_13 = "MR-13",
  MR_15 = "MR-15",
  MR_09 = "MR-09",
  MR_11 = "MR-11",
  MR_06 = "MR-06",
  MU_AG = "MU-AG",
  MU_CC = "MU-CC",
  MU_RO = "MU-RO",
  MU_BL = "MU-BL",
  MU_FL = "MU-FL",
  MU_GP = "MU-GP",
  MU_MO = "MU-MO",
  MU_PA = "MU-PA",
  MU_PW = "MU-PW",
  MU_PL = "MU-PL",
  MU_RR = "MU-RR",
  MU_SA = "MU-SA",
  MX_CMX = "MX-CMX",
  MX_AGU = "MX-AGU",
  MX_BCN = "MX-BCN",
  MX_BCS = "MX-BCS",
  MX_CAM = "MX-CAM",
  MX_COA = "MX-COA",
  MX_COL = "MX-COL",
  MX_CHP = "MX-CHP",
  MX_CHH = "MX-CHH",
  MX_DUR = "MX-DUR",
  MX_GUA = "MX-GUA",
  MX_GRO = "MX-GRO",
  MX_HID = "MX-HID",
  MX_JAL = "MX-JAL",
  MX_MEX = "MX-MEX",
  MX_MIC = "MX-MIC",
  MX_MOR = "MX-MOR",
  MX_NAY = "MX-NAY",
  MX_NLE = "MX-NLE",
  MX_OAX = "MX-OAX",
  MX_PUE = "MX-PUE",
  MX_QUE = "MX-QUE",
  MX_ROO = "MX-ROO",
  MX_SLP = "MX-SLP",
  MX_SIN = "MX-SIN",
  MX_SON = "MX-SON",
  MX_TAB = "MX-TAB",
  MX_TAM = "MX-TAM",
  MX_TLA = "MX-TLA",
  MX_VER = "MX-VER",
  MX_YUC = "MX-YUC",
  MX_ZAC = "MX-ZAC",
  FM_TRK = "FM-TRK",
  FM_KSA = "FM-KSA",
  FM_PNI = "FM-PNI",
  FM_YAP = "FM-YAP",
  MD_GA = "MD-GA",
  MD_BA = "MD-BA",
  MD_BD = "MD-BD",
  MD_CU = "MD-CU",
  MD_AN = "MD-AN",
  MD_BS = "MD-BS",
  MD_BR = "MD-BR",
  MD_CA = "MD-CA",
  MD_CT = "MD-CT",
  MD_CL = "MD-CL",
  MD_CS = "MD-CS",
  MD_CM = "MD-CM",
  MD_CR = "MD-CR",
  MD_DO = "MD-DO",
  MD_DR = "MD-DR",
  MD_DU = "MD-DU",
  MD_ED = "MD-ED",
  MD_FA = "MD-FA",
  MD_FL = "MD-FL",
  MD_GL = "MD-GL",
  MD_HI = "MD-HI",
  MD_IA = "MD-IA",
  MD_LE = "MD-LE",
  MD_NI = "MD-NI",
  MD_OC = "MD-OC",
  MD_OR = "MD-OR",
  MD_RE = "MD-RE",
  MD_RI = "MD-RI",
  MD_SI = "MD-SI",
  MD_SO = "MD-SO",
  MD_ST = "MD-ST",
  MD_SD = "MD-SD",
  MD_SV = "MD-SV",
  MD_TA = "MD-TA",
  MD_TE = "MD-TE",
  MD_UN = "MD-UN",
  MD_SN = "MD-SN",
  MC_FO = "MC-FO",
  MC_JE = "MC-JE",
  MC_CL = "MC-CL",
  MC_CO = "MC-CO",
  MC_GA = "MC-GA",
  MC_SO = "MC-SO",
  MC_LA = "MC-LA",
  MC_MA = "MC-MA",
  MC_MO = "MC-MO",
  MC_MG = "MC-MG",
  MC_MC = "MC-MC",
  MC_MU = "MC-MU",
  MC_PH = "MC-PH",
  MC_SR = "MC-SR",
  MC_SD = "MC-SD",
  MC_SP = "MC-SP",
  MC_VR = "MC-VR",
  MN_1 = "MN-1",
  MN_073 = "MN-073",
  MN_069 = "MN-069",
  MN_071 = "MN-071",
  MN_067 = "MN-067",
  MN_037 = "MN-037",
  MN_061 = "MN-061",
  MN_063 = "MN-063",
  MN_059 = "MN-059",
  MN_057 = "MN-057",
  MN_065 = "MN-065",
  MN_064 = "MN-064",
  MN_039 = "MN-039",
  MN_043 = "MN-043",
  MN_041 = "MN-041",
  MN_053 = "MN-053",
  MN_035 = "MN-035",
  MN_055 = "MN-055",
  MN_049 = "MN-049",
  MN_051 = "MN-051",
  MN_047 = "MN-047",
  MN_046 = "MN-046",
  ME_01 = "ME-01",
  ME_02 = "ME-02",
  ME_03 = "ME-03",
  ME_04 = "ME-04",
  ME_05 = "ME-05",
  ME_06 = "ME-06",
  ME_07 = "ME-07",
  ME_08 = "ME-08",
  ME_09 = "ME-09",
  ME_10 = "ME-10",
  ME_11 = "ME-11",
  ME_12 = "ME-12",
  ME_13 = "ME-13",
  ME_14 = "ME-14",
  ME_15 = "ME-15",
  ME_16 = "ME-16",
  ME_17 = "ME-17",
  ME_18 = "ME-18",
  ME_19 = "ME-19",
  ME_20 = "ME-20",
  ME_21 = "ME-21",
  ME_22 = "ME-22",
  ME_23 = "ME-23",
  ME_24 = "ME-24",
  MA_05 = "MA-05",
  MA_06 = "MA-06",
  MA_12 = "MA-12",
  MA_08 = "MA-08",
  MA_03 = "MA-03",
  MA_10 = "MA-10",
  MA_11 = "MA-11",
  MA_07 = "MA-07",
  MA_02 = "MA-02",
  MA_04 = "MA-04",
  MA_09 = "MA-09",
  MA_01 = "MA-01",
  MA_AGD = "MA-AGD",
  MA_AOU = "MA-AOU",
  MA_ASZ = "MA-ASZ",
  MA_AZI = "MA-AZI",
  MA_BEM = "MA-BEM",
  MA_BES = "MA-BES",
  MA_BER = "MA-BER",
  MA_BRR = "MA-BRR",
  MA_BOD = "MA-BOD",
  MA_BOM = "MA-BOM",
  MA_CAS = "MA-CAS",
  MA_CHE = "MA-CHE",
  MA_CHI = "MA-CHI",
  MA_CHT = "MA-CHT",
  MA_DRI = "MA-DRI",
  MA_ERR = "MA-ERR",
  MA_ESM = "MA-ESM",
  MA_ESI = "MA-ESI",
  MA_FAH = "MA-FAH",
  MA_FES = "MA-FES",
  MA_FIG = "MA-FIG",
  MA_FQH = "MA-FQH",
  MA_GUE = "MA-GUE",
  MA_GUF = "MA-GUF",
  MA_HAJ = "MA-HAJ",
  MA_HAO = "MA-HAO",
  MA_HOC = "MA-HOC",
  MA_IFR = "MA-IFR",
  MA_INE = "MA-INE",
  MA_JDI = "MA-JDI",
  MA_JRA = "MA-JRA",
  MA_KES = "MA-KES",
  MA_KEN = "MA-KEN",
  MA_KHE = "MA-KHE",
  MA_KHN = "MA-KHN",
  MA_KHO = "MA-KHO",
  MA_LAA = "MA-LAA",
  MA_LAR = "MA-LAR",
  MA_MAR = "MA-MAR",
  MA_MDF = "MA-MDF",
  MA_MED = "MA-MED",
  MA_MEK = "MA-MEK",
  MA_MID = "MA-MID",
  MA_MOH = "MA-MOH",
  MA_MOU = "MA-MOU",
  MA_NAD = "MA-NAD",
  MA_NOU = "MA-NOU",
  MA_OUA = "MA-OUA",
  MA_OUD = "MA-OUD",
  MA_OUZ = "MA-OUZ",
  MA_OUJ = "MA-OUJ",
  MA_RAB = "MA-RAB",
  MA_REH = "MA-REH",
  MA_SAF = "MA-SAF",
  MA_SAL = "MA-SAL",
  MA_SEF = "MA-SEF",
  MA_SET = "MA-SET",
  MA_SIB = "MA-SIB",
  MA_SIF = "MA-SIF",
  MA_SIK = "MA-SIK",
  MA_SIL = "MA-SIL",
  MA_SKH = "MA-SKH",
  MA_TNT = "MA-TNT",
  MA_TNG = "MA-TNG",
  MA_TAO = "MA-TAO",
  MA_TAI = "MA-TAI",
  MA_TAF = "MA-TAF",
  MA_TAR = "MA-TAR",
  MA_TAT = "MA-TAT",
  MA_TAZ = "MA-TAZ",
  MA_TET = "MA-TET",
  MA_TIN = "MA-TIN",
  MA_TIZ = "MA-TIZ",
  MA_YUS = "MA-YUS",
  MA_ZAG = "MA-ZAG",
  MZ_MPM = "MZ-MPM",
  MZ_P = "MZ-P",
  MZ_G = "MZ-G",
  MZ_I = "MZ-I",
  MZ_B = "MZ-B",
  MZ_L = "MZ-L",
  MZ_N = "MZ-N",
  MZ_A = "MZ-A",
  MZ_S = "MZ-S",
  MZ_T = "MZ-T",
  MZ_Q = "MZ-Q",
  MM_07 = "MM-07",
  MM_02 = "MM-02",
  MM_03 = "MM-03",
  MM_04 = "MM-04",
  MM_01 = "MM-01",
  MM_05 = "MM-05",
  MM_06 = "MM-06",
  MM_14 = "MM-14",
  MM_11 = "MM-11",
  MM_12 = "MM-12",
  MM_13 = "MM-13",
  MM_15 = "MM-15",
  MM_16 = "MM-16",
  MM_17 = "MM-17",
  MM_18 = "MM-18",
  NA_ER = "NA-ER",
  NA_HA = "NA-HA",
  NA_KA = "NA-KA",
  NA_KE = "NA-KE",
  NA_KW = "NA-KW",
  NA_KH = "NA-KH",
  NA_KU = "NA-KU",
  NA_OW = "NA-OW",
  NA_OH = "NA-OH",
  NA_OS = "NA-OS",
  NA_ON = "NA-ON",
  NA_OT = "NA-OT",
  NA_OD = "NA-OD",
  NA_CA = "NA-CA",
  NR_01 = "NR-01",
  NR_02 = "NR-02",
  NR_03 = "NR-03",
  NR_04 = "NR-04",
  NR_05 = "NR-05",
  NR_06 = "NR-06",
  NR_07 = "NR-07",
  NR_08 = "NR-08",
  NR_09 = "NR-09",
  NR_10 = "NR-10",
  NR_11 = "NR-11",
  NR_12 = "NR-12",
  NR_13 = "NR-13",
  NR_14 = "NR-14",
  NP_1 = "NP-1",
  NP_2 = "NP-2",
  NP_3 = "NP-3",
  NP_4 = "NP-4",
  NP_5 = "NP-5",
  NP_P1 = "NP-P1",
  NP_P2 = "NP-P2",
  NP_P3 = "NP-P3",
  NP_P4 = "NP-P4",
  NP_P5 = "NP-P5",
  NP_P6 = "NP-P6",
  NP_P7 = "NP-P7",
  NP_BA = "NP-BA",
  NP_BH = "NP-BH",
  NP_DH = "NP-DH",
  NP_GA = "NP-GA",
  NP_JA = "NP-JA",
  NP_KA = "NP-KA",
  NP_KO = "NP-KO",
  NP_LU = "NP-LU",
  NP_MA = "NP-MA",
  NP_ME = "NP-ME",
  NP_NA = "NP-NA",
  NP_RA = "NP-RA",
  NP_SA = "NP-SA",
  NP_SE = "NP-SE",
  NL_DR = "NL-DR",
  NL_FL = "NL-FL",
  NL_FR = "NL-FR",
  NL_GE = "NL-GE",
  NL_GR = "NL-GR",
  NL_LI = "NL-LI",
  NL_NB = "NL-NB",
  NL_NH = "NL-NH",
  NL_OV = "NL-OV",
  NL_UT = "NL-UT",
  NL_ZE = "NL-ZE",
  NL_ZH = "NL-ZH",
  NL_AW = "NL-AW",
  NL_CW = "NL-CW",
  NL_SX = "NL-SX",
  NL_BQ1 = "NL-BQ1",
  NL_BQ2 = "NL-BQ2",
  NL_BQ3 = "NL-BQ3",
  NZ_AUK = "NZ-AUK",
  NZ_BOP = "NZ-BOP",
  NZ_CAN = "NZ-CAN",
  NZ_GIS = "NZ-GIS",
  NZ_HKB = "NZ-HKB",
  NZ_MBH = "NZ-MBH",
  NZ_MWT = "NZ-MWT",
  NZ_NSN = "NZ-NSN",
  NZ_NTL = "NZ-NTL",
  NZ_OTA = "NZ-OTA",
  NZ_STL = "NZ-STL",
  NZ_TAS = "NZ-TAS",
  NZ_TKI = "NZ-TKI",
  NZ_WKO = "NZ-WKO",
  NZ_WGN = "NZ-WGN",
  NZ_WTC = "NZ-WTC",
  NZ_CIT = "NZ-CIT",
  NI_BO = "NI-BO",
  NI_CA = "NI-CA",
  NI_CI = "NI-CI",
  NI_CO = "NI-CO",
  NI_ES = "NI-ES",
  NI_GR = "NI-GR",
  NI_JI = "NI-JI",
  NI_LE = "NI-LE",
  NI_MD = "NI-MD",
  NI_MN = "NI-MN",
  NI_MS = "NI-MS",
  NI_MT = "NI-MT",
  NI_NS = "NI-NS",
  NI_SJ = "NI-SJ",
  NI_RI = "NI-RI",
  NI_AN = "NI-AN",
  NI_AS = "NI-AS",
  NE_8 = "NE-8",
  NE_1 = "NE-1",
  NE_2 = "NE-2",
  NE_3 = "NE-3",
  NE_4 = "NE-4",
  NE_5 = "NE-5",
  NE_6 = "NE-6",
  NE_7 = "NE-7",
  NG_FC = "NG-FC",
  NG_AB = "NG-AB",
  NG_AD = "NG-AD",
  NG_AK = "NG-AK",
  NG_AN = "NG-AN",
  NG_BA = "NG-BA",
  NG_BY = "NG-BY",
  NG_BE = "NG-BE",
  NG_BO = "NG-BO",
  NG_CR = "NG-CR",
  NG_DE = "NG-DE",
  NG_EB = "NG-EB",
  NG_ED = "NG-ED",
  NG_EK = "NG-EK",
  NG_EN = "NG-EN",
  NG_GO = "NG-GO",
  NG_IM = "NG-IM",
  NG_JI = "NG-JI",
  NG_KD = "NG-KD",
  NG_KN = "NG-KN",
  NG_KT = "NG-KT",
  NG_KE = "NG-KE",
  NG_KO = "NG-KO",
  NG_KW = "NG-KW",
  NG_LA = "NG-LA",
  NG_NA = "NG-NA",
  NG_NI = "NG-NI",
  NG_OG = "NG-OG",
  NG_ON = "NG-ON",
  NG_OS = "NG-OS",
  NG_OY = "NG-OY",
  NG_PL = "NG-PL",
  NG_RI = "NG-RI",
  NG_SO = "NG-SO",
  NG_TA = "NG-TA",
  NG_YO = "NG-YO",
  NG_ZA = "NG-ZA",
  KP_01 = "KP-01",
  KP_13 = "KP-13",
  KP_14 = "KP-14",
  KP_02 = "KP-02",
  KP_03 = "KP-03",
  KP_04 = "KP-04",
  KP_05 = "KP-05",
  KP_06 = "KP-06",
  KP_07 = "KP-07",
  KP_08 = "KP-08",
  KP_09 = "KP-09",
  KP_10 = "KP-10",
  MK_801 = "MK-801",
  MK_802 = "MK-802",
  MK_201 = "MK-201",
  MK_501 = "MK-501",
  MK_401 = "MK-401",
  MK_601 = "MK-601",
  MK_402 = "MK-402",
  MK_602 = "MK-602",
  MK_803 = "MK-803",
  MK_814 = "MK-814",
  MK_313 = "MK-313",
  MK_815 = "MK-815",
  MK_109 = "MK-109",
  MK_210 = "MK-210",
  MK_816 = "MK-816",
  MK_303 = "MK-303",
  MK_304 = "MK-304",
  MK_203 = "MK-203",
  MK_502 = "MK-502",
  MK_103 = "MK-103",
  MK_406 = "MK-406",
  MK_503 = "MK-503",
  MK_804 = "MK-804",
  MK_405 = "MK-405",
  MK_805 = "MK-805",
  MK_604 = "MK-604",
  MK_102 = "MK-102",
  MK_807 = "MK-807",
  MK_606 = "MK-606",
  MK_205 = "MK-205",
  MK_808 = "MK-808",
  MK_104 = "MK-104",
  MK_307 = "MK-307",
  MK_809 = "MK-809",
  MK_206 = "MK-206",
  MK_407 = "MK-407",
  MK_701 = "MK-701",
  MK_702 = "MK-702",
  MK_504 = "MK-504",
  MK_505 = "MK-505",
  MK_703 = "MK-703",
  MK_704 = "MK-704",
  MK_105 = "MK-105",
  MK_207 = "MK-207",
  MK_308 = "MK-308",
  MK_607 = "MK-607",
  MK_506 = "MK-506",
  MK_106 = "MK-106",
  MK_507 = "MK-507",
  MK_408 = "MK-408",
  MK_310 = "MK-310",
  MK_208 = "MK-208",
  MK_810 = "MK-810",
  MK_311 = "MK-311",
  MK_508 = "MK-508",
  MK_209 = "MK-209",
  MK_409 = "MK-409",
  MK_705 = "MK-705",
  MK_509 = "MK-509",
  MK_107 = "MK-107",
  MK_811 = "MK-811",
  MK_812 = "MK-812",
  MK_706 = "MK-706",
  MK_312 = "MK-312",
  MK_410 = "MK-410",
  MK_813 = "MK-813",
  MK_108 = "MK-108",
  MK_211 = "MK-211",
  MK_817 = "MK-817",
  MK_608 = "MK-608",
  MK_609 = "MK-609",
  MK_403 = "MK-403",
  MK_404 = "MK-404",
  MK_101 = "MK-101",
  MK_301 = "MK-301",
  MK_202 = "MK-202",
  MK_603 = "MK-603",
  MK_806 = "MK-806",
  MK_204 = "MK-204",
  MK_605 = "MK-605",
  NO_42 = "NO-42",
  NO_34 = "NO-34",
  NO_15 = "NO-15",
  NO_18 = "NO-18",
  NO_03 = "NO-03",
  NO_11 = "NO-11",
  NO_54 = "NO-54",
  NO_50 = "NO-50",
  NO_38 = "NO-38",
  NO_46 = "NO-46",
  NO_30 = "NO-30",
  NO_22 = "NO-22",
  NO_21 = "NO-21",
  OM_DA = "OM-DA",
  OM_BS = "OM-BS",
  OM_BJ = "OM-BJ",
  OM_WU = "OM-WU",
  OM_SS = "OM-SS",
  OM_SJ = "OM-SJ",
  OM_ZA = "OM-ZA",
  OM_BU = "OM-BU",
  OM_MA = "OM-MA",
  OM_MU = "OM-MU",
  OM_ZU = "OM-ZU",
  PK_IS = "PK-IS",
  PK_BA = "PK-BA",
  PK_KP = "PK-KP",
  PK_PB = "PK-PB",
  PK_SD = "PK-SD",
  PK_JK = "PK-JK",
  PK_GB = "PK-GB",
  PW_002 = "PW-002",
  PW_004 = "PW-004",
  PW_010 = "PW-010",
  PW_050 = "PW-050",
  PW_100 = "PW-100",
  PW_150 = "PW-150",
  PW_212 = "PW-212",
  PW_214 = "PW-214",
  PW_218 = "PW-218",
  PW_222 = "PW-222",
  PW_224 = "PW-224",
  PW_226 = "PW-226",
  PW_227 = "PW-227",
  PW_228 = "PW-228",
  PW_350 = "PW-350",
  PW_370 = "PW-370",
  PS_BTH = "PS-BTH",
  PS_DEB = "PS-DEB",
  PS_GZA = "PS-GZA",
  PS_HBN = "PS-HBN",
  PS_JEN = "PS-JEN",
  PS_JRH = "PS-JRH",
  PS_JEM = "PS-JEM",
  PS_KYS = "PS-KYS",
  PS_NBS = "PS-NBS",
  PS_NGZ = "PS-NGZ",
  PS_QQA = "PS-QQA",
  PS_RFH = "PS-RFH",
  PS_RBH = "PS-RBH",
  PS_SLT = "PS-SLT",
  PS_TBS = "PS-TBS",
  PS_TKM = "PS-TKM",
  PA_1 = "PA-1",
  PA_4 = "PA-4",
  PA_2 = "PA-2",
  PA_3 = "PA-3",
  PA_5 = "PA-5",
  PA_EM = "PA-EM",
  PA_KY = "PA-KY",
  PA_6 = "PA-6",
  PA_7 = "PA-7",
  PA_NB = "PA-NB",
  PA_8 = "PA-8",
  PA_10 = "PA-10",
  PA_9 = "PA-9",
  PG_NCD = "PG-NCD",
  PG_CPM = "PG-CPM",
  PG_CPK = "PG-CPK",
  PG_EHG = "PG-EHG",
  PG_EBR = "PG-EBR",
  PG_ESW = "PG-ESW",
  PG_EPW = "PG-EPW",
  PG_GPK = "PG-GPK",
  PG_HLA = "PG-HLA",
  PG_JWK = "PG-JWK",
  PG_MPM = "PG-MPM",
  PG_MRL = "PG-MRL",
  PG_MBA = "PG-MBA",
  PG_MPL = "PG-MPL",
  PG_NIK = "PG-NIK",
  PG_NPP = "PG-NPP",
  PG_SAN = "PG-SAN",
  PG_SHM = "PG-SHM",
  PG_WPD = "PG-WPD",
  PG_WHM = "PG-WHM",
  PG_WBK = "PG-WBK",
  PG_NSB = "PG-NSB",
  PY_ASU = "PY-ASU",
  PY_16 = "PY-16",
  PY_10 = "PY-10",
  PY_13 = "PY-13",
  PY_19 = "PY-19",
  PY_5 = "PY-5",
  PY_6 = "PY-6",
  PY_14 = "PY-14",
  PY_11 = "PY-11",
  PY_1 = "PY-1",
  PY_3 = "PY-3",
  PY_4 = "PY-4",
  PY_7 = "PY-7",
  PY_8 = "PY-8",
  PY_12 = "PY-12",
  PY_9 = "PY-9",
  PY_15 = "PY-15",
  PY_2 = "PY-2",
  PE_LMA = "PE-LMA",
  PE_AMA = "PE-AMA",
  PE_ANC = "PE-ANC",
  PE_APU = "PE-APU",
  PE_ARE = "PE-ARE",
  PE_AYA = "PE-AYA",
  PE_CAJ = "PE-CAJ",
  PE_CUS = "PE-CUS",
  PE_CAL = "PE-CAL",
  PE_HUV = "PE-HUV",
  PE_HUC = "PE-HUC",
  PE_ICA = "PE-ICA",
  PE_JUN = "PE-JUN",
  PE_LAL = "PE-LAL",
  PE_LAM = "PE-LAM",
  PE_LIM = "PE-LIM",
  PE_LOR = "PE-LOR",
  PE_MDD = "PE-MDD",
  PE_MOQ = "PE-MOQ",
  PE_PAS = "PE-PAS",
  PE_PIU = "PE-PIU",
  PE_PUN = "PE-PUN",
  PE_SAM = "PE-SAM",
  PE_TAC = "PE-TAC",
  PE_TUM = "PE-TUM",
  PE_UCA = "PE-UCA",
  PH_14 = "PH-14",
  PH_05 = "PH-05",
  PH_02 = "PH-02",
  PH_40 = "PH-40",
  PH_13 = "PH-13",
  PH_03 = "PH-03",
  PH_07 = "PH-07",
  PH_15 = "PH-15",
  PH_11 = "PH-11",
  PH_08 = "PH-08",
  PH_01 = "PH-01",
  PH_41 = "PH-41",
  PH_00 = "PH-00",
  PH_10 = "PH-10",
  PH_12 = "PH-12",
  PH_06 = "PH-06",
  PH_09 = "PH-09",
  PH_ABR = "PH-ABR",
  PH_AGN = "PH-AGN",
  PH_AGS = "PH-AGS",
  PH_AKL = "PH-AKL",
  PH_ALB = "PH-ALB",
  PH_ANT = "PH-ANT",
  PH_APA = "PH-APA",
  PH_AUR = "PH-AUR",
  PH_BAS = "PH-BAS",
  PH_BAN = "PH-BAN",
  PH_BTN = "PH-BTN",
  PH_BTG = "PH-BTG",
  PH_BEN = "PH-BEN",
  PH_BIL = "PH-BIL",
  PH_BOH = "PH-BOH",
  PH_BUK = "PH-BUK",
  PH_BUL = "PH-BUL",
  PH_CAG = "PH-CAG",
  PH_CAN = "PH-CAN",
  PH_CAS = "PH-CAS",
  PH_CAM = "PH-CAM",
  PH_CAP = "PH-CAP",
  PH_CAT = "PH-CAT",
  PH_CAV = "PH-CAV",
  PH_CEB = "PH-CEB",
  PH_NCO = "PH-NCO",
  PH_COM = "PH-COM",
  PH_DAV = "PH-DAV",
  PH_DAS = "PH-DAS",
  PH_DVO = "PH-DVO",
  PH_DAO = "PH-DAO",
  PH_DIN = "PH-DIN",
  PH_EAS = "PH-EAS",
  PH_GUI = "PH-GUI",
  PH_IFU = "PH-IFU",
  PH_ILN = "PH-ILN",
  PH_ILS = "PH-ILS",
  PH_ILI = "PH-ILI",
  PH_ISA = "PH-ISA",
  PH_KAL = "PH-KAL",
  PH_LUN = "PH-LUN",
  PH_LAG = "PH-LAG",
  PH_LAN = "PH-LAN",
  PH_LAS = "PH-LAS",
  PH_LEY = "PH-LEY",
  PH_MAG = "PH-MAG",
  PH_MAD = "PH-MAD",
  PH_MAS = "PH-MAS",
  PH_MDC = "PH-MDC",
  PH_MDR = "PH-MDR",
  PH_MSC = "PH-MSC",
  PH_MSR = "PH-MSR",
  PH_MOU = "PH-MOU",
  PH_NEC = "PH-NEC",
  PH_NER = "PH-NER",
  PH_NSA = "PH-NSA",
  PH_NUE = "PH-NUE",
  PH_NUV = "PH-NUV",
  PH_PLW = "PH-PLW",
  PH_PAM = "PH-PAM",
  PH_PAN = "PH-PAN",
  PH_QUE = "PH-QUE",
  PH_QUI = "PH-QUI",
  PH_RIZ = "PH-RIZ",
  PH_ROM = "PH-ROM",
  PH_WSA = "PH-WSA",
  PH_SAR = "PH-SAR",
  PH_SIG = "PH-SIG",
  PH_SOR = "PH-SOR",
  PH_SCO = "PH-SCO",
  PH_SLE = "PH-SLE",
  PH_SUK = "PH-SUK",
  PH_SLU = "PH-SLU",
  PH_SUN = "PH-SUN",
  PH_SUR = "PH-SUR",
  PH_TAR = "PH-TAR",
  PH_TAW = "PH-TAW",
  PH_ZMB = "PH-ZMB",
  PH_ZAN = "PH-ZAN",
  PH_ZAS = "PH-ZAS",
  PH_ZSI = "PH-ZSI",
  PN_PN = "PN-PN",
  PL_02 = "PL-02",
  PL_04 = "PL-04",
  PL_06 = "PL-06",
  PL_08 = "PL-08",
  PL_10 = "PL-10",
  PL_12 = "PL-12",
  PL_14 = "PL-14",
  PL_16 = "PL-16",
  PL_18 = "PL-18",
  PL_20 = "PL-20",
  PL_22 = "PL-22",
  PL_24 = "PL-24",
  PL_26 = "PL-26",
  PL_28 = "PL-28",
  PL_30 = "PL-30",
  PL_32 = "PL-32",
  PT_01 = "PT-01",
  PT_02 = "PT-02",
  PT_03 = "PT-03",
  PT_04 = "PT-04",
  PT_05 = "PT-05",
  PT_06 = "PT-06",
  PT_07 = "PT-07",
  PT_08 = "PT-08",
  PT_09 = "PT-09",
  PT_10 = "PT-10",
  PT_11 = "PT-11",
  PT_12 = "PT-12",
  PT_13 = "PT-13",
  PT_14 = "PT-14",
  PT_15 = "PT-15",
  PT_16 = "PT-16",
  PT_17 = "PT-17",
  PT_18 = "PT-18",
  PT_20 = "PT-20",
  PT_30 = "PT-30",
  QA_DA = "QA-DA",
  QA_KH = "QA-KH",
  QA_WA = "QA-WA",
  QA_RA = "QA-RA",
  QA_MS = "QA-MS",
  QA_SH = "QA-SH",
  QA_ZA = "QA-ZA",
  QA_US = "QA-US",
  CG_BZV = "CG-BZV",
  CG_11 = "CG-11",
  CG_8 = "CG-8",
  CG_15 = "CG-15",
  CG_5 = "CG-5",
  CG_2 = "CG-2",
  CG_7 = "CG-7",
  CG_9 = "CG-9",
  CG_14 = "CG-14",
  CG_16 = "CG-16",
  CG_12 = "CG-12",
  CG_13 = "CG-13",
  RE_RE = "RE-RE",
  RO_AB = "RO-AB",
  RO_AR = "RO-AR",
  RO_AG = "RO-AG",
  RO_BC = "RO-BC",
  RO_BH = "RO-BH",
  RO_BN = "RO-BN",
  RO_BT = "RO-BT",
  RO_BV = "RO-BV",
  RO_BR = "RO-BR",
  RO_BZ = "RO-BZ",
  RO_CS = "RO-CS",
  RO_CL = "RO-CL",
  RO_CJ = "RO-CJ",
  RO_CT = "RO-CT",
  RO_CV = "RO-CV",
  RO_DB = "RO-DB",
  RO_DJ = "RO-DJ",
  RO_GL = "RO-GL",
  RO_GR = "RO-GR",
  RO_GJ = "RO-GJ",
  RO_HR = "RO-HR",
  RO_HD = "RO-HD",
  RO_IL = "RO-IL",
  RO_IS = "RO-IS",
  RO_IF = "RO-IF",
  RO_MM = "RO-MM",
  RO_MH = "RO-MH",
  RO_MS = "RO-MS",
  RO_NT = "RO-NT",
  RO_OT = "RO-OT",
  RO_PH = "RO-PH",
  RO_SM = "RO-SM",
  RO_SJ = "RO-SJ",
  RO_SB = "RO-SB",
  RO_SV = "RO-SV",
  RO_TR = "RO-TR",
  RO_TM = "RO-TM",
  RO_TL = "RO-TL",
  RO_VS = "RO-VS",
  RO_VL = "RO-VL",
  RO_VN = "RO-VN",
  RO_B = "RO-B",
  RU_AD = "RU-AD",
  RU_AL = "RU-AL",
  RU_BA = "RU-BA",
  RU_BU = "RU-BU",
  RU_CE = "RU-CE",
  RU_CU = "RU-CU",
  RU_DA = "RU-DA",
  RU_IN = "RU-IN",
  RU_KB = "RU-KB",
  RU_KL = "RU-KL",
  RU_KC = "RU-KC",
  RU_KR = "RU-KR",
  RU_KK = "RU-KK",
  RU_KO = "RU-KO",
  RU_ME = "RU-ME",
  RU_MO = "RU-MO",
  RU_SA = "RU-SA",
  RU_SE = "RU-SE",
  RU_TA = "RU-TA",
  RU_TY = "RU-TY",
  RU_UD = "RU-UD",
  RU_ALT = "RU-ALT",
  RU_KAM = "RU-KAM",
  RU_KHA = "RU-KHA",
  RU_KDA = "RU-KDA",
  RU_KYA = "RU-KYA",
  RU_PER = "RU-PER",
  RU_PRI = "RU-PRI",
  RU_STA = "RU-STA",
  RU_ZAB = "RU-ZAB",
  RU_AMU = "RU-AMU",
  RU_ARK = "RU-ARK",
  RU_AST = "RU-AST",
  RU_BEL = "RU-BEL",
  RU_BRY = "RU-BRY",
  RU_CHE = "RU-CHE",
  RU_IRK = "RU-IRK",
  RU_IVA = "RU-IVA",
  RU_KGD = "RU-KGD",
  RU_KLU = "RU-KLU",
  RU_KEM = "RU-KEM",
  RU_KIR = "RU-KIR",
  RU_KOS = "RU-KOS",
  RU_KGN = "RU-KGN",
  RU_KRS = "RU-KRS",
  RU_LEN = "RU-LEN",
  RU_LIP = "RU-LIP",
  RU_MAG = "RU-MAG",
  RU_MOS = "RU-MOS",
  RU_MUR = "RU-MUR",
  RU_NIZ = "RU-NIZ",
  RU_NGR = "RU-NGR",
  RU_NVS = "RU-NVS",
  RU_OMS = "RU-OMS",
  RU_ORE = "RU-ORE",
  RU_ORL = "RU-ORL",
  RU_PNZ = "RU-PNZ",
  RU_PSK = "RU-PSK",
  RU_ROS = "RU-ROS",
  RU_RYA = "RU-RYA",
  RU_SAK = "RU-SAK",
  RU_SAM = "RU-SAM",
  RU_SAR = "RU-SAR",
  RU_SMO = "RU-SMO",
  RU_SVE = "RU-SVE",
  RU_TAM = "RU-TAM",
  RU_TOM = "RU-TOM",
  RU_TUL = "RU-TUL",
  RU_TVE = "RU-TVE",
  RU_TYU = "RU-TYU",
  RU_ULY = "RU-ULY",
  RU_VLA = "RU-VLA",
  RU_VGG = "RU-VGG",
  RU_VLG = "RU-VLG",
  RU_VOR = "RU-VOR",
  RU_YAR = "RU-YAR",
  RU_MOW = "RU-MOW",
  RU_SPE = "RU-SPE",
  RU_YEV = "RU-YEV",
  RU_CHU = "RU-CHU",
  RU_KHM = "RU-KHM",
  RU_NEN = "RU-NEN",
  RU_YAN = "RU-YAN",
  RW_01 = "RW-01",
  RW_02 = "RW-02",
  RW_03 = "RW-03",
  RW_04 = "RW-04",
  RW_05 = "RW-05",
  SH_AC = "SH-AC",
  SH_HL = "SH-HL",
  SH_TA = "SH-TA",
  KN_K = "KN-K",
  KN_N = "KN-N",
  LC_01 = "LC-01",
  LC_12 = "LC-12",
  LC_02 = "LC-02",
  LC_03 = "LC-03",
  LC_05 = "LC-05",
  LC_06 = "LC-06",
  LC_07 = "LC-07",
  LC_08 = "LC-08",
  LC_10 = "LC-10",
  LC_11 = "LC-11",
  PM_PM = "PM-PM",
  VC_01 = "VC-01",
  VC_06 = "VC-06",
  VC_02 = "VC-02",
  VC_03 = "VC-03",
  VC_04 = "VC-04",
  VC_05 = "VC-05",
  WS_AA = "WS-AA",
  WS_AL = "WS-AL",
  WS_AT = "WS-AT",
  WS_FA = "WS-FA",
  WS_GE = "WS-GE",
  WS_GI = "WS-GI",
  WS_PA = "WS-PA",
  WS_SA = "WS-SA",
  WS_TU = "WS-TU",
  WS_VF = "WS-VF",
  WS_VS = "WS-VS",
  SM_01 = "SM-01",
  SM_06 = "SM-06",
  SM_02 = "SM-02",
  SM_07 = "SM-07",
  SM_03 = "SM-03",
  SM_04 = "SM-04",
  SM_05 = "SM-05",
  SM_08 = "SM-08",
  SM_09 = "SM-09",
  ST_01 = "ST-01",
  ST_02 = "ST-02",
  ST_03 = "ST-03",
  ST_04 = "ST-04",
  ST_05 = "ST-05",
  ST_06 = "ST-06",
  ST_P = "ST-P",
  SA_11 = "SA-11",
  SA_08 = "SA-08",
  SA_12 = "SA-12",
  SA_03 = "SA-03",
  SA_05 = "SA-05",
  SA_01 = "SA-01",
  SA_04 = "SA-04",
  SA_14 = "SA-14",
  SA_06 = "SA-06",
  SA_09 = "SA-09",
  SA_02 = "SA-02",
  SA_10 = "SA-10",
  SA_07 = "SA-07",
  SN_DK = "SN-DK",
  SN_DB = "SN-DB",
  SN_FK = "SN-FK",
  SN_KA = "SN-KA",
  SN_KL = "SN-KL",
  SN_KE = "SN-KE",
  SN_KD = "SN-KD",
  SN_LG = "SN-LG",
  SN_MT = "SN-MT",
  SN_SL = "SN-SL",
  SN_SE = "SN-SE",
  SN_TC = "SN-TC",
  SN_TH = "SN-TH",
  SN_ZG = "SN-ZG",
  RS_KM = "RS-KM",
  RS_VO = "RS-VO",
  RS_00 = "RS-00",
  RS_14 = "RS-14",
  RS_11 = "RS-11",
  RS_23 = "RS-23",
  RS_06 = "RS-06",
  RS_04 = "RS-04",
  RS_09 = "RS-09",
  RS_25 = "RS-25",
  RS_28 = "RS-28",
  RS_29 = "RS-29",
  RS_08 = "RS-08",
  RS_17 = "RS-17",
  RS_20 = "RS-20",
  RS_24 = "RS-24",
  RS_26 = "RS-26",
  RS_22 = "RS-22",
  RS_10 = "RS-10",
  RS_13 = "RS-13",
  RS_27 = "RS-27",
  RS_19 = "RS-19",
  RS_18 = "RS-18",
  RS_01 = "RS-01",
  RS_03 = "RS-03",
  RS_02 = "RS-02",
  RS_07 = "RS-07",
  RS_12 = "RS-12",
  RS_21 = "RS-21",
  RS_15 = "RS-15",
  RS_05 = "RS-05",
  RS_16 = "RS-16",
  SC_01 = "SC-01",
  SC_02 = "SC-02",
  SC_03 = "SC-03",
  SC_05 = "SC-05",
  SC_04 = "SC-04",
  SC_06 = "SC-06",
  SC_07 = "SC-07",
  SC_08 = "SC-08",
  SC_09 = "SC-09",
  SC_10 = "SC-10",
  SC_11 = "SC-11",
  SC_12 = "SC-12",
  SC_13 = "SC-13",
  SC_14 = "SC-14",
  SC_15 = "SC-15",
  SC_16 = "SC-16",
  SC_26 = "SC-26",
  SC_27 = "SC-27",
  SC_24 = "SC-24",
  SC_17 = "SC-17",
  SC_18 = "SC-18",
  SC_19 = "SC-19",
  SC_20 = "SC-20",
  SC_21 = "SC-21",
  SC_25 = "SC-25",
  SC_22 = "SC-22",
  SC_23 = "SC-23",
  SL_W = "SL-W",
  SL_E = "SL-E",
  SL_N = "SL-N",
  SL_NW = "SL-NW",
  SL_S = "SL-S",
  SG_01 = "SG-01",
  SG_02 = "SG-02",
  SG_03 = "SG-03",
  SG_04 = "SG-04",
  SG_05 = "SG-05",
  SK_BC = "SK-BC",
  SK_BL = "SK-BL",
  SK_KI = "SK-KI",
  SK_NI = "SK-NI",
  SK_PV = "SK-PV",
  SK_TC = "SK-TC",
  SK_TA = "SK-TA",
  SK_ZI = "SK-ZI",
  SI_001 = "SI-001",
  SI_213 = "SI-213",
  SI_195 = "SI-195",
  SI_002 = "SI-002",
  SI_148 = "SI-148",
  SI_149 = "SI-149",
  SI_003 = "SI-003",
  SI_150 = "SI-150",
  SI_004 = "SI-004",
  SI_005 = "SI-005",
  SI_006 = "SI-006",
  SI_151 = "SI-151",
  SI_007 = "SI-007",
  SI_008 = "SI-008",
  SI_009 = "SI-009",
  SI_152 = "SI-152",
  SI_011 = "SI-011",
  SI_012 = "SI-012",
  SI_013 = "SI-013",
  SI_014 = "SI-014",
  SI_153 = "SI-153",
  SI_196 = "SI-196",
  SI_015 = "SI-015",
  SI_016 = "SI-016",
  SI_017 = "SI-017",
  SI_018 = "SI-018",
  SI_019 = "SI-019",
  SI_154 = "SI-154",
  SI_020 = "SI-020",
  SI_155 = "SI-155",
  SI_021 = "SI-021",
  SI_156 = "SI-156",
  SI_022 = "SI-022",
  SI_157 = "SI-157",
  SI_023 = "SI-023",
  SI_024 = "SI-024",
  SI_025 = "SI-025",
  SI_026 = "SI-026",
  SI_027 = "SI-027",
  SI_028 = "SI-028",
  SI_207 = "SI-207",
  SI_029 = "SI-029",
  SI_030 = "SI-030",
  SI_031 = "SI-031",
  SI_158 = "SI-158",
  SI_032 = "SI-032",
  SI_159 = "SI-159",
  SI_160 = "SI-160",
  SI_161 = "SI-161",
  SI_162 = "SI-162",
  SI_034 = "SI-034",
  SI_035 = "SI-035",
  SI_036 = "SI-036",
  SI_037 = "SI-037",
  SI_038 = "SI-038",
  SI_039 = "SI-039",
  SI_040 = "SI-040",
  SI_041 = "SI-041",
  SI_163 = "SI-163",
  SI_042 = "SI-042",
  SI_043 = "SI-043",
  SI_044 = "SI-044",
  SI_045 = "SI-045",
  SI_046 = "SI-046",
  SI_047 = "SI-047",
  SI_048 = "SI-048",
  SI_049 = "SI-049",
  SI_164 = "SI-164",
  SI_050 = "SI-050",
  SI_197 = "SI-197",
  SI_165 = "SI-165",
  SI_051 = "SI-051",
  SI_052 = "SI-052",
  SI_053 = "SI-053",
  SI_166 = "SI-166",
  SI_054 = "SI-054",
  SI_055 = "SI-055",
  SI_056 = "SI-056",
  SI_057 = "SI-057",
  SI_058 = "SI-058",
  SI_059 = "SI-059",
  SI_060 = "SI-060",
  SI_061 = "SI-061",
  SI_062 = "SI-062",
  SI_063 = "SI-063",
  SI_208 = "SI-208",
  SI_064 = "SI-064",
  SI_065 = "SI-065",
  SI_066 = "SI-066",
  SI_167 = "SI-167",
  SI_067 = "SI-067",
  SI_068 = "SI-068",
  SI_069 = "SI-069",
  SI_198 = "SI-198",
  SI_070 = "SI-070",
  SI_168 = "SI-168",
  SI_071 = "SI-071",
  SI_072 = "SI-072",
  SI_073 = "SI-073",
  SI_074 = "SI-074",
  SI_169 = "SI-169",
  SI_075 = "SI-075",
  SI_212 = "SI-212",
  SI_170 = "SI-170",
  SI_076 = "SI-076",
  SI_199 = "SI-199",
  SI_077 = "SI-077",
  SI_078 = "SI-078",
  SI_079 = "SI-079",
  SI_080 = "SI-080",
  SI_081 = "SI-081",
  SI_082 = "SI-082",
  SI_083 = "SI-083",
  SI_084 = "SI-084",
  SI_085 = "SI-085",
  SI_086 = "SI-086",
  SI_171 = "SI-171",
  SI_087 = "SI-087",
  SI_088 = "SI-088",
  SI_089 = "SI-089",
  SI_090 = "SI-090",
  SI_091 = "SI-091",
  SI_092 = "SI-092",
  SI_172 = "SI-172",
  SI_093 = "SI-093",
  SI_200 = "SI-200",
  SI_173 = "SI-173",
  SI_094 = "SI-094",
  SI_174 = "SI-174",
  SI_095 = "SI-095",
  SI_175 = "SI-175",
  SI_096 = "SI-096",
  SI_097 = "SI-097",
  SI_098 = "SI-098",
  SI_099 = "SI-099",
  SI_100 = "SI-100",
  SI_101 = "SI-101",
  SI_102 = "SI-102",
  SI_103 = "SI-103",
  SI_176 = "SI-176",
  SI_209 = "SI-209",
  SI_201 = "SI-201",
  SI_104 = "SI-104",
  SI_177 = "SI-177",
  SI_106 = "SI-106",
  SI_105 = "SI-105",
  SI_107 = "SI-107",
  SI_108 = "SI-108",
  SI_178 = "SI-178",
  SI_109 = "SI-109",
  SI_110 = "SI-110",
  SI_111 = "SI-111",
  SI_112 = "SI-112",
  SI_113 = "SI-113",
  SI_114 = "SI-114",
  SI_179 = "SI-179",
  SI_180 = "SI-180",
  SI_202 = "SI-202",
  SI_115 = "SI-115",
  SI_203 = "SI-203",
  SI_181 = "SI-181",
  SI_204 = "SI-204",
  SI_182 = "SI-182",
  SI_116 = "SI-116",
  SI_210 = "SI-210",
  SI_205 = "SI-205",
  SI_033 = "SI-033",
  SI_183 = "SI-183",
  SI_117 = "SI-117",
  SI_118 = "SI-118",
  SI_119 = "SI-119",
  SI_120 = "SI-120",
  SI_211 = "SI-211",
  SI_121 = "SI-121",
  SI_122 = "SI-122",
  SI_123 = "SI-123",
  SI_124 = "SI-124",
  SI_206 = "SI-206",
  SI_125 = "SI-125",
  SI_194 = "SI-194",
  SI_126 = "SI-126",
  SI_127 = "SI-127",
  SI_184 = "SI-184",
  SI_010 = "SI-010",
  SI_128 = "SI-128",
  SI_129 = "SI-129",
  SI_130 = "SI-130",
  SI_185 = "SI-185",
  SI_186 = "SI-186",
  SI_131 = "SI-131",
  SI_132 = "SI-132",
  SI_133 = "SI-133",
  SI_187 = "SI-187",
  SI_134 = "SI-134",
  SI_188 = "SI-188",
  SI_135 = "SI-135",
  SI_136 = "SI-136",
  SI_137 = "SI-137",
  SI_138 = "SI-138",
  SI_139 = "SI-139",
  SI_189 = "SI-189",
  SI_140 = "SI-140",
  SI_141 = "SI-141",
  SI_142 = "SI-142",
  SI_143 = "SI-143",
  SI_144 = "SI-144",
  SI_190 = "SI-190",
  SI_146 = "SI-146",
  SI_191 = "SI-191",
  SI_147 = "SI-147",
  SI_192 = "SI-192",
  SI_193 = "SI-193",
  SB_CT = "SB-CT",
  SB_CE = "SB-CE",
  SB_CH = "SB-CH",
  SB_GU = "SB-GU",
  SB_IS = "SB-IS",
  SB_MK = "SB-MK",
  SB_ML = "SB-ML",
  SB_RB = "SB-RB",
  SB_TE = "SB-TE",
  SB_WE = "SB-WE",
  SO_AW = "SO-AW",
  SO_BK = "SO-BK",
  SO_BN = "SO-BN",
  SO_BR = "SO-BR",
  SO_BY = "SO-BY",
  SO_GA = "SO-GA",
  SO_GE = "SO-GE",
  SO_HI = "SO-HI",
  SO_JD = "SO-JD",
  SO_JH = "SO-JH",
  SO_MU = "SO-MU",
  SO_NU = "SO-NU",
  SO_SA = "SO-SA",
  SO_SD = "SO-SD",
  SO_SH = "SO-SH",
  SO_SO = "SO-SO",
  SO_TO = "SO-TO",
  SO_WO = "SO-WO",
  ZA_EC = "ZA-EC",
  ZA_FS = "ZA-FS",
  ZA_GP = "ZA-GP",
  ZA_KZN = "ZA-KZN",
  ZA_LP = "ZA-LP",
  ZA_MP = "ZA-MP",
  ZA_NC = "ZA-NC",
  ZA_NW = "ZA-NW",
  ZA_WC = "ZA-WC",
  GS_GS = "GS-GS",
  KR_11 = "KR-11",
  KR_26 = "KR-26",
  KR_27 = "KR-27",
  KR_30 = "KR-30",
  KR_29 = "KR-29",
  KR_28 = "KR-28",
  KR_31 = "KR-31",
  KR_43 = "KR-43",
  KR_44 = "KR-44",
  KR_42 = "KR-42",
  KR_41 = "KR-41",
  KR_47 = "KR-47",
  KR_48 = "KR-48",
  KR_45 = "KR-45",
  KR_46 = "KR-46",
  KR_49 = "KR-49",
  KR_50 = "KR-50",
  SS_EC = "SS-EC",
  SS_EE = "SS-EE",
  SS_JG = "SS-JG",
  SS_LK = "SS-LK",
  SS_BN = "SS-BN",
  SS_UY = "SS-UY",
  SS_NU = "SS-NU",
  SS_WR = "SS-WR",
  SS_BW = "SS-BW",
  SS_EW = "SS-EW",
  ES_AN = "ES-AN",
  ES_AR = "ES-AR",
  ES_AS = "ES-AS",
  ES_CN = "ES-CN",
  ES_CB = "ES-CB",
  ES_CL = "ES-CL",
  ES_CM = "ES-CM",
  ES_CT = "ES-CT",
  ES_CE = "ES-CE",
  ES_EX = "ES-EX",
  ES_GA = "ES-GA",
  ES_IB = "ES-IB",
  ES_RI = "ES-RI",
  ES_MD = "ES-MD",
  ES_ML = "ES-ML",
  ES_MC = "ES-MC",
  ES_NC = "ES-NC",
  ES_PV = "ES-PV",
  ES_VC = "ES-VC",
  ES_C = "ES-C",
  ES_VI = "ES-VI",
  ES_AB = "ES-AB",
  ES_A = "ES-A",
  ES_AL = "ES-AL",
  ES_O = "ES-O",
  ES_AV = "ES-AV",
  ES_BA = "ES-BA",
  ES_B = "ES-B",
  ES_BI = "ES-BI",
  ES_BU = "ES-BU",
  ES_CC = "ES-CC",
  ES_CA = "ES-CA",
  ES_S = "ES-S",
  ES_CS = "ES-CS",
  ES_CR = "ES-CR",
  ES_CO = "ES-CO",
  ES_CU = "ES-CU",
  ES_SS = "ES-SS",
  ES_GI = "ES-GI",
  ES_GR = "ES-GR",
  ES_GU = "ES-GU",
  ES_H = "ES-H",
  ES_HU = "ES-HU",
  ES_PM = "ES-PM",
  ES_J = "ES-J",
  ES_LO = "ES-LO",
  ES_GC = "ES-GC",
  ES_LE = "ES-LE",
  ES_L = "ES-L",
  ES_LU = "ES-LU",
  ES_M = "ES-M",
  ES_MA = "ES-MA",
  ES_MU = "ES-MU",
  ES_NA = "ES-NA",
  ES_OR = "ES-OR",
  ES_P = "ES-P",
  ES_PO = "ES-PO",
  ES_SA = "ES-SA",
  ES_TF = "ES-TF",
  ES_SG = "ES-SG",
  ES_SE = "ES-SE",
  ES_SO = "ES-SO",
  ES_T = "ES-T",
  ES_TE = "ES-TE",
  ES_TO = "ES-TO",
  ES_V = "ES-V",
  ES_VA = "ES-VA",
  ES_ZA = "ES-ZA",
  ES_Z = "ES-Z",
  LK_1 = "LK-1",
  LK_2 = "LK-2",
  LK_3 = "LK-3",
  LK_4 = "LK-4",
  LK_5 = "LK-5",
  LK_6 = "LK-6",
  LK_7 = "LK-7",
  LK_8 = "LK-8",
  LK_9 = "LK-9",
  LK_11 = "LK-11",
  LK_12 = "LK-12",
  LK_13 = "LK-13",
  LK_21 = "LK-21",
  LK_22 = "LK-22",
  LK_23 = "LK-23",
  LK_31 = "LK-31",
  LK_32 = "LK-32",
  LK_33 = "LK-33",
  LK_41 = "LK-41",
  LK_42 = "LK-42",
  LK_43 = "LK-43",
  LK_44 = "LK-44",
  LK_45 = "LK-45",
  LK_51 = "LK-51",
  LK_52 = "LK-52",
  LK_53 = "LK-53",
  LK_61 = "LK-61",
  LK_62 = "LK-62",
  LK_71 = "LK-71",
  LK_72 = "LK-72",
  LK_81 = "LK-81",
  LK_82 = "LK-82",
  LK_91 = "LK-91",
  LK_92 = "LK-92",
  SD_RS = "SD-RS",
  SD_GZ = "SD-GZ",
  SD_KH = "SD-KH",
  SD_GD = "SD-GD",
  SD_NR = "SD-NR",
  SD_NW = "SD-NW",
  SD_NB = "SD-NB",
  SD_NO = "SD-NO",
  SD_DW = "SD-DW",
  SD_GK = "SD-GK",
  SD_DS = "SD-DS",
  SD_KS = "SD-KS",
  SD_KA = "SD-KA",
  SD_DN = "SD-DN",
  SD_KN = "SD-KN",
  SD_DE = "SD-DE",
  SD_SI = "SD-SI",
  SD_DC = "SD-DC",
  SR_BR = "SR-BR",
  SR_CM = "SR-CM",
  SR_CR = "SR-CR",
  SR_MA = "SR-MA",
  SR_NI = "SR-NI",
  SR_PR = "SR-PR",
  SR_PM = "SR-PM",
  SR_SA = "SR-SA",
  SR_SI = "SR-SI",
  SR_WA = "SR-WA",
  SJ_SJ = "SJ-SJ",
  SE_K = "SE-K",
  SE_W = "SE-W",
  SE_I = "SE-I",
  SE_X = "SE-X",
  SE_N = "SE-N",
  SE_Z = "SE-Z",
  SE_F = "SE-F",
  SE_H = "SE-H",
  SE_G = "SE-G",
  SE_BD = "SE-BD",
  SE_M = "SE-M",
  SE_AB = "SE-AB",
  SE_D = "SE-D",
  SE_C = "SE-C",
  SE_S = "SE-S",
  SE_AC = "SE-AC",
  SE_Y = "SE-Y",
  SE_U = "SE-U",
  SE_O = "SE-O",
  SE_T = "SE-T",
  SE_E = "SE-E",
  CH_AG = "CH-AG",
  CH_AR = "CH-AR",
  CH_AI = "CH-AI",
  CH_BL = "CH-BL",
  CH_BS = "CH-BS",
  CH_BE = "CH-BE",
  CH_FR = "CH-FR",
  CH_GE = "CH-GE",
  CH_GL = "CH-GL",
  CH_GR = "CH-GR",
  CH_JU = "CH-JU",
  CH_LU = "CH-LU",
  CH_NE = "CH-NE",
  CH_NW = "CH-NW",
  CH_OW = "CH-OW",
  CH_SG = "CH-SG",
  CH_SH = "CH-SH",
  CH_SZ = "CH-SZ",
  CH_SO = "CH-SO",
  CH_TG = "CH-TG",
  CH_TI = "CH-TI",
  CH_UR = "CH-UR",
  CH_VS = "CH-VS",
  CH_VD = "CH-VD",
  CH_ZG = "CH-ZG",
  CH_ZH = "CH-ZH",
  SY_HA = "SY-HA",
  SY_LA = "SY-LA",
  SY_QU = "SY-QU",
  SY_RA = "SY-RA",
  SY_SU = "SY-SU",
  SY_DR = "SY-DR",
  SY_DY = "SY-DY",
  SY_DI = "SY-DI",
  SY_HL = "SY-HL",
  SY_HM = "SY-HM",
  SY_HI = "SY-HI",
  SY_ID = "SY-ID",
  SY_RD = "SY-RD",
  SY_TA = "SY-TA",
  TW_CHA = "TW-CHA",
  TW_CYI = "TW-CYI",
  TW_CYQ = "TW-CYQ",
  TW_HSZ = "TW-HSZ",
  TW_HSQ = "TW-HSQ",
  TW_HUA = "TW-HUA",
  TW_KHH = "TW-KHH",
  TW_KEE = "TW-KEE",
  TW_KIN = "TW-KIN",
  TW_LIE = "TW-LIE",
  TW_MIA = "TW-MIA",
  TW_NAN = "TW-NAN",
  TW_NWT = "TW-NWT",
  TW_PEN = "TW-PEN",
  TW_PIF = "TW-PIF",
  TW_TXG = "TW-TXG",
  TW_TNN = "TW-TNN",
  TW_TPE = "TW-TPE",
  TW_TTT = "TW-TTT",
  TW_TAO = "TW-TAO",
  TW_ILA = "TW-ILA",
  TW_YUN = "TW-YUN",
  TJ_DU = "TJ-DU",
  TJ_GB = "TJ-GB",
  TJ_KT = "TJ-KT",
  TJ_SU = "TJ-SU",
  TJ_RA = "TJ-RA",
  TZ_01 = "TZ-01",
  TZ_02 = "TZ-02",
  TZ_03 = "TZ-03",
  TZ_27 = "TZ-27",
  TZ_04 = "TZ-04",
  TZ_05 = "TZ-05",
  TZ_06 = "TZ-06",
  TZ_07 = "TZ-07",
  TZ_28 = "TZ-28",
  TZ_08 = "TZ-08",
  TZ_09 = "TZ-09",
  TZ_10 = "TZ-10",
  TZ_11 = "TZ-11",
  TZ_12 = "TZ-12",
  TZ_26 = "TZ-26",
  TZ_13 = "TZ-13",
  TZ_14 = "TZ-14",
  TZ_15 = "TZ-15",
  TZ_16 = "TZ-16",
  TZ_17 = "TZ-17",
  TZ_18 = "TZ-18",
  TZ_29 = "TZ-29",
  TZ_19 = "TZ-19",
  TZ_20 = "TZ-20",
  TZ_21 = "TZ-21",
  TZ_22 = "TZ-22",
  TZ_30 = "TZ-30",
  TZ_23 = "TZ-23",
  TZ_31 = "TZ-31",
  TZ_24 = "TZ-24",
  TZ_25 = "TZ-25",
  TH_10 = "TH-10",
  TH_S = "TH-S",
  TH_37 = "TH-37",
  TH_15 = "TH-15",
  TH_38 = "TH-38",
  TH_31 = "TH-31",
  TH_24 = "TH-24",
  TH_18 = "TH-18",
  TH_36 = "TH-36",
  TH_22 = "TH-22",
  TH_50 = "TH-50",
  TH_57 = "TH-57",
  TH_20 = "TH-20",
  TH_86 = "TH-86",
  TH_46 = "TH-46",
  TH_62 = "TH-62",
  TH_71 = "TH-71",
  TH_40 = "TH-40",
  TH_81 = "TH-81",
  TH_52 = "TH-52",
  TH_51 = "TH-51",
  TH_42 = "TH-42",
  TH_16 = "TH-16",
  TH_58 = "TH-58",
  TH_44 = "TH-44",
  TH_49 = "TH-49",
  TH_26 = "TH-26",
  TH_73 = "TH-73",
  TH_48 = "TH-48",
  TH_30 = "TH-30",
  TH_60 = "TH-60",
  TH_80 = "TH-80",
  TH_55 = "TH-55",
  TH_96 = "TH-96",
  TH_39 = "TH-39",
  TH_43 = "TH-43",
  TH_12 = "TH-12",
  TH_13 = "TH-13",
  TH_94 = "TH-94",
  TH_82 = "TH-82",
  TH_93 = "TH-93",
  TH_56 = "TH-56",
  TH_67 = "TH-67",
  TH_76 = "TH-76",
  TH_66 = "TH-66",
  TH_65 = "TH-65",
  TH_54 = "TH-54",
  TH_14 = "TH-14",
  TH_83 = "TH-83",
  TH_25 = "TH-25",
  TH_77 = "TH-77",
  TH_85 = "TH-85",
  TH_70 = "TH-70",
  TH_21 = "TH-21",
  TH_45 = "TH-45",
  TH_27 = "TH-27",
  TH_47 = "TH-47",
  TH_11 = "TH-11",
  TH_74 = "TH-74",
  TH_75 = "TH-75",
  TH_19 = "TH-19",
  TH_91 = "TH-91",
  TH_17 = "TH-17",
  TH_33 = "TH-33",
  TH_90 = "TH-90",
  TH_64 = "TH-64",
  TH_72 = "TH-72",
  TH_84 = "TH-84",
  TH_32 = "TH-32",
  TH_63 = "TH-63",
  TH_92 = "TH-92",
  TH_23 = "TH-23",
  TH_34 = "TH-34",
  TH_41 = "TH-41",
  TH_61 = "TH-61",
  TH_53 = "TH-53",
  TH_95 = "TH-95",
  TH_35 = "TH-35",
  TL_AL = "TL-AL",
  TL_AN = "TL-AN",
  TL_BA = "TL-BA",
  TL_BO = "TL-BO",
  TL_CO = "TL-CO",
  TL_DI = "TL-DI",
  TL_ER = "TL-ER",
  TL_LA = "TL-LA",
  TL_LI = "TL-LI",
  TL_MT = "TL-MT",
  TL_MF = "TL-MF",
  TL_OE = "TL-OE",
  TL_VI = "TL-VI",
  TG_C = "TG-C",
  TG_K = "TG-K",
  TG_M = "TG-M",
  TG_P = "TG-P",
  TG_S = "TG-S",
  TO_01 = "TO-01",
  TO_02 = "TO-02",
  TO_03 = "TO-03",
  TO_04 = "TO-04",
  TO_05 = "TO-05",
  TT_ARI = "TT-ARI",
  TT_CHA = "TT-CHA",
  TT_CTT = "TT-CTT",
  TT_DMN = "TT-DMN",
  TT_MRC = "TT-MRC",
  TT_PED = "TT-PED",
  TT_POS = "TT-POS",
  TT_PRT = "TT-PRT",
  TT_PTF = "TT-PTF",
  TT_SFO = "TT-SFO",
  TT_SGE = "TT-SGE",
  TT_SIP = "TT-SIP",
  TT_SJL = "TT-SJL",
  TT_TOB = "TT-TOB",
  TT_TUP = "TT-TUP",
  TN_31 = "TN-31",
  TN_13 = "TN-13",
  TN_23 = "TN-23",
  TN_81 = "TN-81",
  TN_71 = "TN-71",
  TN_32 = "TN-32",
  TN_41 = "TN-41",
  TN_42 = "TN-42",
  TN_73 = "TN-73",
  TN_12 = "TN-12",
  TN_14 = "TN-14",
  TN_33 = "TN-33",
  TN_53 = "TN-53",
  TN_82 = "TN-82",
  TN_52 = "TN-52",
  TN_21 = "TN-21",
  TN_61 = "TN-61",
  TN_43 = "TN-43",
  TN_34 = "TN-34",
  TN_51 = "TN-51",
  TN_83 = "TN-83",
  TN_72 = "TN-72",
  TN_11 = "TN-11",
  TN_22 = "TN-22",
  TR_01 = "TR-01",
  TR_02 = "TR-02",
  TR_03 = "TR-03",
  TR_04 = "TR-04",
  TR_68 = "TR-68",
  TR_05 = "TR-05",
  TR_06 = "TR-06",
  TR_07 = "TR-07",
  TR_75 = "TR-75",
  TR_08 = "TR-08",
  TR_09 = "TR-09",
  TR_10 = "TR-10",
  TR_74 = "TR-74",
  TR_72 = "TR-72",
  TR_69 = "TR-69",
  TR_11 = "TR-11",
  TR_12 = "TR-12",
  TR_13 = "TR-13",
  TR_14 = "TR-14",
  TR_15 = "TR-15",
  TR_16 = "TR-16",
  TR_17 = "TR-17",
  TR_18 = "TR-18",
  TR_19 = "TR-19",
  TR_20 = "TR-20",
  TR_21 = "TR-21",
  TR_81 = "TR-81",
  TR_22 = "TR-22",
  TR_23 = "TR-23",
  TR_24 = "TR-24",
  TR_25 = "TR-25",
  TR_26 = "TR-26",
  TR_27 = "TR-27",
  TR_28 = "TR-28",
  TR_29 = "TR-29",
  TR_30 = "TR-30",
  TR_31 = "TR-31",
  TR_76 = "TR-76",
  TR_32 = "TR-32",
  TR_34 = "TR-34",
  TR_35 = "TR-35",
  TR_46 = "TR-46",
  TR_78 = "TR-78",
  TR_70 = "TR-70",
  TR_36 = "TR-36",
  TR_37 = "TR-37",
  TR_38 = "TR-38",
  TR_71 = "TR-71",
  TR_39 = "TR-39",
  TR_40 = "TR-40",
  TR_79 = "TR-79",
  TR_41 = "TR-41",
  TR_42 = "TR-42",
  TR_43 = "TR-43",
  TR_44 = "TR-44",
  TR_45 = "TR-45",
  TR_47 = "TR-47",
  TR_33 = "TR-33",
  TR_48 = "TR-48",
  TR_49 = "TR-49",
  TR_50 = "TR-50",
  TR_51 = "TR-51",
  TR_52 = "TR-52",
  TR_80 = "TR-80",
  TR_53 = "TR-53",
  TR_54 = "TR-54",
  TR_55 = "TR-55",
  TR_56 = "TR-56",
  TR_57 = "TR-57",
  TR_58 = "TR-58",
  TR_63 = "TR-63",
  TR_73 = "TR-73",
  TR_59 = "TR-59",
  TR_60 = "TR-60",
  TR_61 = "TR-61",
  TR_62 = "TR-62",
  TR_64 = "TR-64",
  TR_65 = "TR-65",
  TR_77 = "TR-77",
  TR_66 = "TR-66",
  TR_67 = "TR-67",
  TM_A = "TM-A",
  TM_B = "TM-B",
  TM_D = "TM-D",
  TM_L = "TM-L",
  TM_M = "TM-M",
  TM_S = "TM-S",
  TC_TC = "TC-TC",
  TV_FUN = "TV-FUN",
  TV_NMG = "TV-NMG",
  TV_NMA = "TV-NMA",
  TV_NIT = "TV-NIT",
  TV_NUI = "TV-NUI",
  TV_NKF = "TV-NKF",
  TV_NKL = "TV-NKL",
  TV_VAI = "TV-VAI",
  UG_C = "UG-C",
  UG_E = "UG-E",
  UG_N = "UG-N",
  UG_W = "UG-W",
  UG_314 = "UG-314",
  UG_301 = "UG-301",
  UG_322 = "UG-322",
  UG_323 = "UG-323",
  UG_315 = "UG-315",
  UG_324 = "UG-324",
  UG_216 = "UG-216",
  UG_316 = "UG-316",
  UG_302 = "UG-302",
  UG_303 = "UG-303",
  UG_217 = "UG-217",
  UG_218 = "UG-218",
  UG_201 = "UG-201",
  UG_235 = "UG-235",
  UG_420 = "UG-420",
  UG_117 = "UG-117",
  UG_219 = "UG-219",
  UG_118 = "UG-118",
  UG_220 = "UG-220",
  UG_225 = "UG-225",
  UG_416 = "UG-416",
  UG_401 = "UG-401",
  UG_430 = "UG-430",
  UG_402 = "UG-402",
  UG_202 = "UG-202",
  UG_221 = "UG-221",
  UG_119 = "UG-119",
  UG_233 = "UG-233",
  UG_120 = "UG-120",
  UG_226 = "UG-226",
  UG_317 = "UG-317",
  UG_121 = "UG-121",
  UG_304 = "UG-304",
  UG_403 = "UG-403",
  UG_417 = "UG-417",
  UG_203 = "UG-203",
  UG_418 = "UG-418",
  UG_204 = "UG-204",
  UG_318 = "UG-318",
  UG_404 = "UG-404",
  UG_405 = "UG-405",
  UG_213 = "UG-213",
  UG_427 = "UG-427",
  UG_428 = "UG-428",
  UG_237 = "UG-237",
  UG_101 = "UG-101",
  UG_222 = "UG-222",
  UG_122 = "UG-122",
  UG_102 = "UG-102",
  UG_205 = "UG-205",
  UG_413 = "UG-413",
  UG_414 = "UG-414",
  UG_206 = "UG-206",
  UG_236 = "UG-236",
  UG_335 = "UG-335",
  UG_126 = "UG-126",
  UG_406 = "UG-406",
  UG_207 = "UG-207",
  UG_112 = "UG-112",
  UG_433 = "UG-433",
  UG_407 = "UG-407",
  UG_103 = "UG-103",
  UG_227 = "UG-227",
  UG_432 = "UG-432",
  UG_419 = "UG-419",
  UG_421 = "UG-421",
  UG_408 = "UG-408",
  UG_434 = "UG-434",
  UG_305 = "UG-305",
  UG_319 = "UG-319",
  UG_325 = "UG-325",
  UG_306 = "UG-306",
  UG_208 = "UG-208",
  UG_333 = "UG-333",
  UG_228 = "UG-228",
  UG_123 = "UG-123",
  UG_422 = "UG-422",
  UG_415 = "UG-415",
  UG_125 = "UG-125",
  UG_326 = "UG-326",
  UG_307 = "UG-307",
  UG_229 = "UG-229",
  UG_104 = "UG-104",
  UG_124 = "UG-124",
  UG_114 = "UG-114",
  UG_336 = "UG-336",
  UG_223 = "UG-223",
  UG_320 = "UG-320",
  UG_105 = "UG-105",
  UG_409 = "UG-409",
  UG_214 = "UG-214",
  UG_209 = "UG-209",
  UG_410 = "UG-410",
  UG_423 = "UG-423",
  UG_115 = "UG-115",
  UG_308 = "UG-308",
  UG_309 = "UG-309",
  UG_106 = "UG-106",
  UG_107 = "UG-107",
  UG_108 = "UG-108",
  UG_334 = "UG-334",
  UG_311 = "UG-311",
  UG_116 = "UG-116",
  UG_109 = "UG-109",
  UG_230 = "UG-230",
  UG_234 = "UG-234",
  UG_224 = "UG-224",
  UG_327 = "UG-327",
  UG_310 = "UG-310",
  UG_231 = "UG-231",
  UG_424 = "UG-424",
  UG_411 = "UG-411",
  UG_328 = "UG-328",
  UG_337 = "UG-337",
  UG_331 = "UG-331",
  UG_329 = "UG-329",
  UG_321 = "UG-321",
  UG_312 = "UG-312",
  UG_332 = "UG-332",
  UG_210 = "UG-210",
  UG_110 = "UG-110",
  UG_429 = "UG-429",
  UG_425 = "UG-425",
  UG_431 = "UG-431",
  UG_412 = "UG-412",
  UG_435 = "UG-435",
  UG_111 = "UG-111",
  UG_232 = "UG-232",
  UG_426 = "UG-426",
  UG_215 = "UG-215",
  UG_211 = "UG-211",
  UG_212 = "UG-212",
  UG_113 = "UG-113",
  UG_313 = "UG-313",
  UG_330 = "UG-330",
  UA_71 = "UA-71",
  UA_74 = "UA-74",
  UA_77 = "UA-77",
  UA_12 = "UA-12",
  UA_14 = "UA-14",
  UA_26 = "UA-26",
  UA_63 = "UA-63",
  UA_65 = "UA-65",
  UA_68 = "UA-68",
  UA_35 = "UA-35",
  UA_32 = "UA-32",
  UA_09 = "UA-09",
  UA_46 = "UA-46",
  UA_48 = "UA-48",
  UA_51 = "UA-51",
  UA_53 = "UA-53",
  UA_56 = "UA-56",
  UA_59 = "UA-59",
  UA_61 = "UA-61",
  UA_05 = "UA-05",
  UA_07 = "UA-07",
  UA_21 = "UA-21",
  UA_23 = "UA-23",
  UA_18 = "UA-18",
  UA_43 = "UA-43",
  UA_30 = "UA-30",
  UA_40 = "UA-40",
  AE_AZ = "AE-AZ",
  AE_AJ = "AE-AJ",
  AE_FU = "AE-FU",
  AE_SH = "AE-SH",
  AE_DU = "AE-DU",
  AE_RK = "AE-RK",
  AE_UQ = "AE-UQ",
  GB_ENG = "GB-ENG",
  GB_NIR = "GB-NIR",
  GB_SCT = "GB-SCT",
  GB_WLS = "GB-WLS",
  US_AL = "US-AL",
  US_AK = "US-AK",
  US_AZ = "US-AZ",
  US_AR = "US-AR",
  US_CA = "US-CA",
  US_CO = "US-CO",
  US_CT = "US-CT",
  US_DE = "US-DE",
  US_FL = "US-FL",
  US_GA = "US-GA",
  US_HI = "US-HI",
  US_ID = "US-ID",
  US_IL = "US-IL",
  US_IN = "US-IN",
  US_IA = "US-IA",
  US_KS = "US-KS",
  US_KY = "US-KY",
  US_LA = "US-LA",
  US_ME = "US-ME",
  US_MD = "US-MD",
  US_MA = "US-MA",
  US_MI = "US-MI",
  US_MN = "US-MN",
  US_MS = "US-MS",
  US_MO = "US-MO",
  US_MT = "US-MT",
  US_NE = "US-NE",
  US_NV = "US-NV",
  US_NH = "US-NH",
  US_NJ = "US-NJ",
  US_NM = "US-NM",
  US_NY = "US-NY",
  US_NC = "US-NC",
  US_ND = "US-ND",
  US_OH = "US-OH",
  US_OK = "US-OK",
  US_OR = "US-OR",
  US_PA = "US-PA",
  US_RI = "US-RI",
  US_SC = "US-SC",
  US_SD = "US-SD",
  US_TN = "US-TN",
  US_TX = "US-TX",
  US_UT = "US-UT",
  US_VT = "US-VT",
  US_VA = "US-VA",
  US_WA = "US-WA",
  US_WV = "US-WV",
  US_WI = "US-WI",
  US_WY = "US-WY",
  US_DC = "US-DC",
  US_AS = "US-AS",
  US_GU = "US-GU",
  US_MP = "US-MP",
  US_PR = "US-PR",
  US_UM = "US-UM",
  US_VI = "US-VI",
  UM_81 = "UM-81",
  UM_84 = "UM-84",
  UM_86 = "UM-86",
  UM_67 = "UM-67",
  UM_89 = "UM-89",
  UM_71 = "UM-71",
  UM_76 = "UM-76",
  UM_95 = "UM-95",
  UM_79 = "UM-79",
  VI_VI = "VI-VI",
  UY_AR = "UY-AR",
  UY_CA = "UY-CA",
  UY_CL = "UY-CL",
  UY_CO = "UY-CO",
  UY_DU = "UY-DU",
  UY_FS = "UY-FS",
  UY_FD = "UY-FD",
  UY_LA = "UY-LA",
  UY_MA = "UY-MA",
  UY_MO = "UY-MO",
  UY_PA = "UY-PA",
  UY_RN = "UY-RN",
  UY_RV = "UY-RV",
  UY_RO = "UY-RO",
  UY_SA = "UY-SA",
  UY_SJ = "UY-SJ",
  UY_SO = "UY-SO",
  UY_TA = "UY-TA",
  UY_TT = "UY-TT",
  UZ_TK = "UZ-TK",
  UZ_AN = "UZ-AN",
  UZ_BU = "UZ-BU",
  UZ_FA = "UZ-FA",
  UZ_JI = "UZ-JI",
  UZ_NG = "UZ-NG",
  UZ_NW = "UZ-NW",
  UZ_QA = "UZ-QA",
  UZ_SA = "UZ-SA",
  UZ_SI = "UZ-SI",
  UZ_SU = "UZ-SU",
  UZ_TO = "UZ-TO",
  UZ_XO = "UZ-XO",
  UZ_QR = "UZ-QR",
  VU_MAP = "VU-MAP",
  VU_PAM = "VU-PAM",
  VU_SAM = "VU-SAM",
  VU_SEE = "VU-SEE",
  VU_TAE = "VU-TAE",
  VU_TOB = "VU-TOB",
  VA_VA = "VA-VA",
  VE_W = "VE-W",
  VE_A = "VE-A",
  VE_Z = "VE-Z",
  VE_B = "VE-B",
  VE_C = "VE-C",
  VE_D = "VE-D",
  VE_E = "VE-E",
  VE_F = "VE-F",
  VE_G = "VE-G",
  VE_H = "VE-H",
  VE_Y = "VE-Y",
  VE_I = "VE-I",
  VE_J = "VE-J",
  VE_K = "VE-K",
  VE_L = "VE-L",
  VE_M = "VE-M",
  VE_N = "VE-N",
  VE_O = "VE-O",
  VE_P = "VE-P",
  VE_R = "VE-R",
  VE_S = "VE-S",
  VE_T = "VE-T",
  VE_X = "VE-X",
  VE_U = "VE-U",
  VE_V = "VE-V",
  VN_44 = "VN-44",
  VN_43 = "VN-43",
  VN_54 = "VN-54",
  VN_53 = "VN-53",
  VN_55 = "VN-55",
  VN_56 = "VN-56",
  VN_50 = "VN-50",
  VN_31 = "VN-31",
  VN_57 = "VN-57",
  VN_58 = "VN-58",
  VN_40 = "VN-40",
  VN_59 = "VN-59",
  VN_04 = "VN-04",
  VN_33 = "VN-33",
  VN_72 = "VN-72",
  VN_71 = "VN-71",
  VN_39 = "VN-39",
  VN_45 = "VN-45",
  VN_30 = "VN-30",
  VN_03 = "VN-03",
  VN_63 = "VN-63",
  VN_23 = "VN-23",
  VN_61 = "VN-61",
  VN_73 = "VN-73",
  VN_14 = "VN-14",
  VN_66 = "VN-66",
  VN_34 = "VN-34",
  VN_47 = "VN-47",
  VN_28 = "VN-28",
  VN_01 = "VN-01",
  VN_35 = "VN-35",
  VN_09 = "VN-09",
  VN_02 = "VN-02",
  VN_41 = "VN-41",
  VN_67 = "VN-67",
  VN_22 = "VN-22",
  VN_18 = "VN-18",
  VN_36 = "VN-36",
  VN_68 = "VN-68",
  VN_32 = "VN-32",
  VN_24 = "VN-24",
  VN_27 = "VN-27",
  VN_29 = "VN-29",
  VN_13 = "VN-13",
  VN_25 = "VN-25",
  VN_52 = "VN-52",
  VN_05 = "VN-05",
  VN_37 = "VN-37",
  VN_20 = "VN-20",
  VN_69 = "VN-69",
  VN_21 = "VN-21",
  VN_26 = "VN-26",
  VN_46 = "VN-46",
  VN_51 = "VN-51",
  VN_07 = "VN-07",
  VN_49 = "VN-49",
  VN_70 = "VN-70",
  VN_06 = "VN-06",
  VN_CT = "VN-CT",
  VN_DN = "VN-DN",
  VN_HN = "VN-HN",
  VN_HP = "VN-HP",
  VN_SG = "VN-SG",
  WF_AL = "WF-AL",
  WF_SG = "WF-SG",
  WF_UV = "WF-UV",
  YE_SA = "YE-SA",
  YE_AB = "YE-AB",
  YE_AD = "YE-AD",
  YE_DA = "YE-DA",
  YE_BA = "YE-BA",
  YE_HU = "YE-HU",
  YE_JA = "YE-JA",
  YE_MR = "YE-MR",
  YE_MW = "YE-MW",
  YE_AM = "YE-AM",
  YE_SU = "YE-SU",
  YE_DH = "YE-DH",
  YE_HD = "YE-HD",
  YE_HJ = "YE-HJ",
  YE_IB = "YE-IB",
  YE_LA = "YE-LA",
  YE_MA = "YE-MA",
  YE_RA = "YE-RA",
  YE_SD = "YE-SD",
  YE_SN = "YE-SN",
  YE_SH = "YE-SH",
  YE_TA = "YE-TA",
  ZM_02 = "ZM-02",
  ZM_08 = "ZM-08",
  ZM_03 = "ZM-03",
  ZM_04 = "ZM-04",
  ZM_09 = "ZM-09",
  ZM_05 = "ZM-05",
  ZM_06 = "ZM-06",
  ZM_07 = "ZM-07",
  ZM_01 = "ZM-01",
  ZM_10 = "ZM-10",
  ZW_BU = "ZW-BU",
  ZW_HA = "ZW-HA",
  ZW_MA = "ZW-MA",
  ZW_MC = "ZW-MC",
  ZW_ME = "ZW-ME",
  ZW_MW = "ZW-MW",
  ZW_MV = "ZW-MV",
  ZW_MN = "ZW-MN",
  ZW_MS = "ZW-MS",
  ZW_MI = "ZW-MI"
}
export type ISO3166_2 = `${ISO3166_2_Alpha2}` | ISO3166_2_Alpha2
